/* ═══════════════════════════════════════════════════════
   CONFIG
═══════════════════════════════════════════════════════ */

const COLORS = [
  { name: 'Rosa',         hex: '#EDD0D1' },
  { name: 'Beige',        hex: '#D4AD85' },
  { name: 'Verde Salvia', hex: '#A9B5A7' },
  { name: 'Azzurro',      hex: '#AFE4F3' },
  { name: 'Rosso',        hex: '#D0021B' },
  { name: 'Arancione',    hex: '#EC9F20' },
  { name: 'Fucsia',       hex: '#E256C6' },
  { name: 'Blu',          hex: '#4A90E2' },
  { name: 'Nero',         hex: '#000000' },
  { name: 'Bianco',       hex: '#FFFFFF' },
  { name: 'Grigio',       hex: '#9B9B9B' },
  { name: 'Giallo',       hex: '#F8E71C' },
  { name: 'Verde',        hex: '#69AF15' },
  { name: 'Lilla',        hex: '#B06CEB' },
];

/*
  type: 'svg'     → decorazione SVG vettoriale (renderizzata con Path2D)
  type: 'svg-img' → SVG come immagine (supporta nested transforms; colori sostituiti via template)
  type: 'png'     → PNG con trasparenza (renderizzata come immagine)
  colorize        → (solo PNG) la PNG viene tinta con il colore lettera
  color           → (solo SVG) colore fisso della decorazione
  src             → (solo PNG) URL CDN Shopify
  fill:'LETTER_COLOR' su un path SVG → usa il colore lettera corrente
  svgTemplate     → (svg-img) stringa SVG con placeholder {{LETTER_COLOR}}
*/
const DECORATIONS = [
  {
    id: 1, name: 'Orsetto', icon: '🐻', type: 'svg-img',
    svgViewBox: [0, 0, 500, 500],
    svgTemplate: `<svg style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 500 500" height="100%" width="100%"><g transform="matrix(0.060182,0,0,0.060182,250,250)"><g transform="matrix(1,0,0,1,-7308.333333,-5168.75)"><g transform="matrix(4.166667,0,0,4.166667,0,0)"><path style="fill:rgb(178,142,92);" d="M1362.84,506.508C1482.39,439.607 1622.76,410.396 1789.52,428.918C1942.9,145.861 2288.67,397.902 2096.59,615.355C2136.99,655.342 2162.75,698.506 2167.41,746.25L2140.05,753.214C2190.2,809.298 2184.07,867.689 2160.25,922.382L2124.55,897.534C2127.41,965.385 2119.43,1033.48 2070.13,1085.18C2100.24,1080.16 2138.01,1085.91 2180.7,1104.65C2196.46,1074.99 2221.87,1055.26 2246.95,1046.4C2372.62,1002 2463.84,1121.2 2447.71,1259.52C2440.49,1321.51 2371.89,1395.08 2275.73,1373.44C2277.28,1416.56 2251.12,1473.13 2231.17,1521.35C2254.8,1557.85 2305.62,1483.81 2399.17,1546.41C2475.48,1515.97 2540,1583.62 2537.72,1633.58C2600.06,1656.41 2602.09,1723.96 2591.89,1780.97C2587.3,1806.57 2557.43,1876.36 2544.53,1901.95C2495.06,2000.07 2420.41,2054.27 2316.1,2112.3C2145.03,2179.28 2031.92,2093.58 2014.7,1985.79C1870.38,2034.98 1711.45,2044.34 1567.33,1980.27L1501.64,2012.66C1476.76,2087.77 1408.25,2125.36 1348.51,2132.96C1187.6,2153.41 1061.5,2066.98 951.284,1903.8C940.872,1888.38 915.928,1837.39 914.113,1828.86C886.169,1697.52 928.021,1649.39 977.825,1618.93C1007.16,1575.73 1017.49,1554.99 1053.22,1543.52C1092.41,1530.93 1145.6,1540.24 1172.83,1516.78C1148.27,1487.7 1139.88,1459.87 1138.38,1430.13C1134.23,1347.59 1160.44,1259.51 1240.36,1225.71C1272.21,1212.25 1295.84,1206.06 1376.21,1232.1C1385.93,1235.25 1398.99,1234.37 1406.1,1225.23C1352.48,1201.6 1309.26,1159.33 1282.25,1088.09L1264.67,1120.54C1235.97,1074.2 1229.81,1024.51 1228.98,960.783L1200,993.686C1175.66,948.278 1175.94,904.643 1185.57,861.682C964.283,839.364 1021.61,348.429 1362.84,506.508Z"/></g><g transform="matrix(-4.166667,0,0,4.166667,15007.416667,-741.945833)"><path style="fill:white;" d="M1312.94,1480.21C1310.64,1479.33 1309.34,1478.71 1309.34,1478.71C1309.34,1478.71 1310.75,1479.2 1312.94,1480.21C1324.86,1484.78 1363.67,1496.52 1388,1467.1C1403.31,1448.59 1404.54,1427.71 1403.43,1416.87C1400.07,1383.94 1382.78,1370.67 1362.88,1365.57C1353.6,1363.19 1323.85,1355.46 1328.9,1355.91C1344.01,1357.26 1362.68,1360.54 1375.32,1359.7C1409.6,1357.43 1438.23,1308.92 1389.37,1261.9C1373.02,1246.16 1329.75,1224.44 1296.26,1225.78C1210.44,1229.22 1156.31,1352.33 1166.11,1418.22C1169.65,1442.02 1178.09,1472.81 1196.95,1497.54C1220.37,1528.24 1261.17,1543.1 1279.49,1544.26C1305.84,1545.92 1336,1542.41 1337.78,1512.6C1338.88,1494.19 1320.83,1483.84 1312.94,1480.21ZM2296.7,1655.65C2286.84,1660.38 2273.74,1668.14 2269.52,1677.53C2261.24,1695.9 2276.62,1725.06 2301.95,1730.84C2311.71,1733.06 2351.07,1710.78 2365.81,1706.72C2383.21,1701.93 2408.78,1699.23 2414.29,1691.87C2500.21,1577.2 2415.87,1408.27 2305.52,1403.85C2272.03,1402.51 2228.76,1420.08 2211.99,1435.36C2153.36,1488.79 2187.64,1547.56 2244.64,1541.75C2253.58,1540.84 2251.12,1541.36 2245.34,1543.85C2225.28,1552.5 2200.96,1569.37 2198.35,1594.93C2197.24,1605.78 2201.01,1623.34 2208.79,1638.82C2215.94,1653.05 2235.66,1665.36 2250.66,1666.08C2265.14,1666.78 2284.46,1660.42 2296.7,1655.65C2303.34,1652.46 2308.51,1650.65 2308.51,1650.65C2308.51,1650.65 2303.8,1652.88 2296.7,1655.65Z"/></g><g transform="matrix(4.166667,0,0,4.166667,0,0)"><path style="fill:white;" d="M2150.96,2038.7C2228.8,2104.26 2366.43,2043.42 2425.58,1975.23C2475.57,1917.6 2569.86,1810.97 2504.68,1700.05C2403.19,1527.35 2270.34,1662.38 2204.84,1732.54C2139.33,1802.69 2042.37,1947.26 2150.96,2038.7Z"/></g><g transform="matrix(4.166667,0,0,-4.166667,-4618.541667,15462.791667)"><path style="fill:white;" d="M2150.96,2038.7C2254.29,2159.67 2366.43,2043.42 2425.58,1975.23C2475.57,1917.6 2574.28,1808.25 2504.68,1700.05C2435.08,1591.85 2270.34,1662.38 2204.84,1732.54C2139.33,1802.69 2058.75,1930.77 2150.96,2038.7Z"/></g><g transform="matrix(4.166667,0,0,4.166667,0,0)"><path style="fill:{{LETTER_COLOR}};" d="M1750.94,1352.63C1784.69,1149.14 1990.61,1050.52 2178,1117.69C2169.72,1146.19 2178.84,1175.61 2212.46,1189.43C2196.59,1202.51 2190.46,1220.22 2188.58,1233.62C2184.07,1265.75 2197.87,1291.07 2215.56,1304.12C2233.46,1317.32 2255.28,1318.07 2255.28,1318.07C2255.28,1318.07 2248.64,1348.55 2265.75,1368.74C2233.76,1526.48 2087.69,1751.32 1888.21,1996.07C1721.56,1951.93 1567.83,1861.69 1420.27,1749.58C1386.49,1680.89 1348.83,1609.78 1306.5,1559.73C1332.88,1551.81 1345.85,1528.57 1345.45,1498.3C1408.83,1503.07 1438.04,1389.31 1375.43,1369.12C1447.95,1365.64 1442.11,1271.7 1391.96,1247.88C1534.42,1187.19 1655.24,1240.47 1750.94,1352.63Z"/></g><g transform="matrix(4.166667,0,0,4.166667,0,0)"><path style="fill:white;" d="M1201.96,783.015C1099.85,722.066 1136.41,542.885 1265.71,536.425C1286.82,535.37 1306.8,539.647 1328.9,555.477C1272.19,624.395 1221.39,692.686 1201.96,783.015Z"/></g><g transform="matrix(-0.622346,4.119925,-4.119925,-0.622346,11687.666667,-2610.575)"><path style="fill:white;" d="M1198.39,771.764C1160.67,755.791 1119.68,740.942 1106.93,710.138C1072.81,627.654 1115.63,576.255 1171.49,544.032C1222.67,514.503 1295.11,545.436 1306.1,551.777C1249.39,620.694 1217.82,681.435 1198.39,771.764Z"/></g><g transform="matrix(4.157838,0.2711,-0.2711,4.157838,1641.154167,-820.154167)"><path d="M1463.34,857.214C1430.56,877.542 1440.91,924.295 1454.86,945.498C1491.05,1000.53 1535.5,970.663 1534.05,921.6C1533.23,893.782 1500.98,833.87 1463.34,857.214Z"/></g><g transform="matrix(4.157838,0.2711,-0.2711,4.157838,261.539583,-402.235417)"><path d="M1463.34,857.214C1430.56,877.542 1440.35,924.673 1454.86,945.498C1493.17,1000.51 1547.05,965.33 1535.31,917.67C1532.01,904.245 1529.93,895.07 1523.63,882.679C1511.01,857.833 1488.45,841.638 1463.34,857.214Z"/></g><g transform="matrix(4.166667,0,0,4.166667,-16.3515,-1.114217)"><path style="fill:white;" d="M1480.33,875.307C1463.72,886.034 1472.34,920.97 1497.38,907.618C1518.54,896.33 1496.93,864.579 1480.33,875.307Z"/></g><g transform="matrix(4.166667,0,0,4.166667,1339.383333,-417.441667)"><path style="fill:white;" d="M1480.33,875.307C1463.72,886.034 1472.34,920.97 1497.38,907.618C1518.54,896.33 1496.93,864.579 1480.33,875.307Z"/></g><g transform="matrix(4.166667,0,0,4.166667,0,0)"><path style="fill:white;" d="M1499.24,1074.38C1510.4,969.109 1640.1,872.017 1793.24,891.604C1891.62,904.188 1972.21,1015.36 1913.7,1119.35C1849.94,1153.99 1811.61,1188.05 1786.53,1221.79C1724.21,1273.36 1481.14,1245.17 1499.24,1074.38Z"/></g><g transform="matrix(4.166667,0,0,4.166667,0,0)"><path d="M1691.7,1051.93C1576.11,1060.18 1561.02,978.471 1644.38,935.217C1732.51,889.487 1817.26,968.369 1707.83,1045.06C1707.83,1045.06 1743.17,1155.17 1749.7,1155.48C1756.41,1155.81 1773.17,1148.83 1791.29,1134.19C1814,1115.84 1837.73,1084.67 1833.79,1031.99C1833.48,1027.83 1845.74,1028.76 1846.27,1032.9C1848.43,1050.11 1839.09,1096.58 1819.46,1121.27C1813.95,1128.2 1806.89,1135.57 1798.74,1141.73C1780.07,1155.83 1757.67,1167.77 1737.62,1175.64C1711.4,1185.92 1686.22,1187.86 1663.48,1185.72C1628.59,1182.43 1598.82,1167.46 1575.16,1141.94C1572.54,1139.1 1580.9,1131.6 1583.06,1134.5C1590.51,1144.51 1606.03,1160.17 1636.24,1169.74C1647.16,1173.2 1668.91,1176.16 1684.25,1175.37C1708.61,1174.11 1732.45,1167.2 1734.08,1161.79C1737.49,1150.49 1691.7,1051.93 1691.7,1051.93Z"/></g></g></g></svg>`,
  },
  {
    id: 2, name: 'Arcobaleno', icon: '🌈', type: 'svg',
    svgViewBox: [0, 0, 500, 500],
    shadow: { color: 'rgba(0,0,0,0.38)', blur: 14, offsetX: 0, offsetY: 4 },
    svgPaths: [
      { d: 'M318.182,178.748C318.728,179.702 318.725,179.678 319.36,180.586C321.68,183.721 323.649,187.467 324.281,188.639C325.246,190.165 325.181,190.182 326.31,191.592C326.852,192.822 326.862,192.802 328.604,196.445C333.768,207.244 333.441,207.377 333.895,208.312C335.914,212.465 339.421,222.95 340.033,225.598C340.418,227.268 340.788,227.733 341.013,228.607C343.047,236.524 342.492,236.684 342.903,237.261C342.988,237.381 343.991,237.617 344.46,237.429C344.462,237.428 346.248,235.565 346.403,235.403C348.982,232.712 355.047,229.519 355.366,229.323C362.203,226.417 366.321,225.14 374.504,225.382C378.553,225.502 384.805,227.394 387.4,228.701C395.585,232.822 398.775,237.194 399.933,238.121C400.118,238.269 400.372,238.314 400.558,238.463C400.696,238.701 400.867,238.473 401.005,238.71C401.086,238.849 400.924,239.043 400.984,239.193C401.049,239.357 401.251,239.43 401.35,239.576C402.18,240.802 402.045,240.88 403.331,242.622C406.675,247.153 410.272,256.509 411.109,261.56C411.71,265.186 413.5,263.466 418.378,265.768C432.078,272.233 434.054,284.819 434.915,290.436C434.935,291.006 435.107,295.825 434.722,297.557C433.511,303.006 433.553,302.999 433.375,303.449C433.292,303.659 431.615,308.574 428.755,311.728C419.736,321.677 409.379,320.782 404.492,321.409C401.003,321.857 401.016,321.327 397.501,321.29C388.288,321.195 388.299,320.942 387.499,320.975C383.012,321.157 383.014,320.915 352.5,320.856C344.608,320.84 329.622,320.534 329.499,320.526C323.691,320.141 311.705,321.681 302.817,313.173C293.989,304.723 293.379,297.571 292.205,291.578C292.156,290.883 292.107,290.188 292.058,289.493C292.016,286.871 291.564,279.667 295.917,270.705C297.932,266.555 298.208,266.733 301.049,263.093C303.844,259.511 302.567,259.063 302.25,254.517C301.964,250.413 301.596,250.488 300.929,246.435C300.511,243.898 300.255,243.975 299.793,241.438C299.127,237.775 297.474,233.316 296.77,230.431C296.177,228.002 290.854,214.072 289.879,212.3C289.501,211.614 285.659,204.632 285.099,203.754C273.638,185.78 268.918,182.893 266.482,180.518C264.963,179.037 264.812,179.225 263.292,177.748C261.499,176.006 261.343,176.225 259.406,174.615C256.286,172.023 256.199,172.173 252.646,170.215C245.194,166.108 244.703,166.318 242.659,165.189C239.86,163.643 229.615,161.685 225.498,161.59C214.597,161.337 213.715,162.342 208.449,163.205C200.84,164.451 198.45,167.229 193.366,169.103C190.855,170.028 190.762,170.38 187.565,172.59C186.397,173.398 180.699,177.338 173.819,183.829C171.27,186.234 164.777,194.527 163.432,196.45C159.039,202.729 159.297,202.874 158.244,204.354C151.542,213.779 145.345,232.821 143.804,238.575C140.899,249.421 140.841,251.371 140.807,252.511C140.741,254.714 142.215,255.49 144.197,257.76C148.377,262.546 151.406,270.911 151.814,274.454C152.515,280.528 152.229,282.733 152.136,283.447C151.682,286.948 152.013,286.985 151.163,290.4L151.06,291.258C148.762,297.601 144.85,308.573 130.392,313.165C124.898,314.91 124.755,313.983 104.444,314.156C102.691,314.134 102.703,314.133 102.551,314.132C102.055,314.129 102.077,314.151 101.585,314.148C98.885,314.062 73.48,313.834 72.482,313.78C65.771,313.418 65.774,313.889 61.501,313.488C56.354,313.005 55.672,313.416 52.51,313.259C41.436,312.706 35.997,313.412 32.505,312.483C29.98,311.812 22.556,310.843 16.374,304.625C11.73,299.955 10.313,294.078 9.547,291.48C9.471,290.815 9.396,290.149 9.32,289.483C9.158,286.88 7.423,273.357 18.413,262.413C24.346,256.504 30.971,255.908 32.378,255.228C34.347,254.276 34.634,249.765 35.559,247.526C37.335,243.223 37.523,242.47 38.202,241.336C40.733,237.107 40.623,237.053 40.865,236.7C41.886,235.208 41.69,235.112 42.574,233.545C42.737,233.401 42.979,233.365 43.142,233.221C43.341,233.045 43.462,232.795 43.642,232.6C45.817,230.243 45.709,230.168 48.053,228.012C54.131,222.422 58,221.204 61.615,219.776C64.426,218.666 64.519,219.077 67.466,218.366C69.103,217.972 76.702,217.191 84.404,219.758C87.275,220.715 87.198,220.884 90.066,221.875C91.612,222.923 91.604,222.925 91.752,223.005C93.111,223.733 93.108,223.722 93.275,223.836C96.501,226.044 97.936,227.368 98.309,227.713C100.217,229.473 101.154,230.813 102.033,228.37C102.165,228.003 102.036,227.98 102.837,223.551C103.922,221.626 104.005,221.679 104.801,219.623C106.79,213.404 106.596,213.342 109.277,207.391C112.455,200.34 112.493,200.276 112.839,199.693C114.775,196.429 114.991,194.582 121.931,183.785C131.223,169.332 139.706,161.66 141.655,159.65C148.726,152.358 161.602,142.57 171.387,138.239C173.412,137.343 174.535,136.457 177.416,135.282C184.646,132.332 187.521,131.494 188.422,131.232C194.014,129.602 194.052,129.751 194.535,129.599C196.499,128.982 196.506,129.051 198.54,128.734C198.786,128.696 200.531,128.134 204.498,127.486C206.017,127.238 211.371,126.786 211.555,126.752C213.059,126.474 213.029,126.031 227.504,126.128C232.076,126.159 232.002,126.776 236.544,127.089C241.246,127.413 245.253,128.588 246.454,128.774C249.076,129.182 248.982,129.542 251.577,130.058C255.19,130.776 262.704,133.723 263.653,134.095C273.533,137.969 280.015,142.447 281.573,143.377C293.751,150.645 304.899,162.214 308.578,166.432C313.686,172.289 317.468,177.723 318.182,178.748Z', fill: 'rgb(236,236,236)', transform: [1,0,0,1,27.951702,49.16518] },
      { d: 'M270.404,86.955C276.781,88.928 286.196,91.215 305.272,100.93C306.451,101.53 306.316,101.749 309.555,103.403C314.1,105.724 323.12,112.09 324.264,112.897C325.376,113.73 325.367,113.724 326.56,114.433C327.017,114.831 337.113,122.89 337.204,122.959C338.13,123.945 338.123,123.927 339.145,124.827C342.746,127.99 352.027,137.35 355.118,140.84C356.012,141.85 360.153,146.9 360.587,147.43C364.786,152.551 373.274,164.595 376.473,170.516C377.814,172.997 378.102,173.137 380.366,177.593C380.547,177.904 382.131,180.615 382.739,181.415C385.184,188.226 386.271,188.933 388.43,194.527C391.281,201.916 391.442,201.844 393.935,209.359C394.442,210.887 394.525,210.838 394.962,212.386C395.126,212.966 395.282,212.914 397.184,219.592C397.709,221.438 400.454,233.257 400.73,234.447C400.741,234.605 400.864,236.421 400.864,236.421C400.668,237.091 400.331,236.935 400.226,237.634C400.155,238.107 400.628,237.991 400.558,238.463C400.372,238.314 400.118,238.269 399.933,238.121C398.775,237.194 395.585,232.822 387.4,228.701C384.805,227.394 378.553,225.502 374.504,225.382C366.321,225.14 362.203,226.417 355.366,229.323C355.288,229.084 355.98,229.033 355.902,228.795C355.84,228.604 354.988,228.338 354.53,226.493C353.628,222.856 348.669,209.004 347.607,206.453C345.701,201.878 345.627,201.914 345.471,201.512C342.793,194.616 341.613,195.21 338.595,188.454C338.214,187.601 337.423,185.831 332.537,178.469C331.754,177.336 331.767,177.355 330.938,176.251C329.923,174.698 329.953,174.694 328.84,173.208C327.732,171.811 327.839,171.744 326.664,170.396C324.86,168.101 324.943,168.057 323.136,165.779C318.95,160.505 317.468,158.851 308.582,150.413C307.038,148.947 306.984,149.036 305.376,147.647C301.833,144.588 301.14,144.291 299.321,142.714C296.284,140.081 296.138,140.281 294.718,139.203C292.068,137.192 292.008,137.307 291.78,137.132C290.312,136.004 290.343,135.983 288.719,135.074C285.343,133.185 283.604,132.062 282.493,131.512C278.134,129.353 277.352,128.552 269.666,125.184C264.294,122.83 262.212,122.37 261.536,122.22C260.535,121.813 260.55,121.837 259.539,121.408C258.429,120.937 258.493,120.821 258.395,120.787C257.797,120.576 257.162,120.495 256.545,120.354C256.234,120.284 255.921,120.224 255.61,120.154C253.943,119.739 240.469,116.39 234.522,116.108C222.176,115.524 214.358,113.78 188.433,120.259C184.895,120.882 184.909,120.842 184.612,120.931C184.445,120.981 184.542,121.128 182.691,121.971C182.297,122.15 181.889,122.299 181.495,122.478C177.965,123.772 177.961,123.757 177.659,123.88C171.94,126.209 172.033,126.386 171.535,126.582C171.135,126.74 168.377,127.825 166.631,128.768C163.02,130.718 162.969,130.608 162.662,130.788C157.746,133.681 157.535,133.324 153.408,136.37C151.411,137.843 151.321,137.692 149.29,139.211C145.06,142.376 139.54,146.35 135.358,150.351C131.244,154.286 130.971,153.974 127.121,158.161C121.795,163.952 115.001,172.791 114.975,172.829C113.123,175.59 112.986,175.482 111.234,178.295C110.491,179.488 110.247,179.296 109.511,180.508C103.456,190.481 103.469,190.482 102.484,192.493C101.021,194.576 100.888,194.47 100.77,194.656C100.613,194.903 100.622,195.233 100.465,195.48C99.716,197.121 97.648,201.895 97.406,202.454C94.041,210.224 93.533,211.588 93.232,212.396C92.992,213.04 90.936,218.564 90.347,220.486C90.209,220.938 90.204,221.423 90.066,221.875C87.198,220.884 87.275,220.715 84.404,219.758C76.702,217.191 69.103,217.972 67.466,218.366C64.519,219.077 64.426,218.666 61.615,219.776C58,221.204 54.131,222.422 48.053,228.012C45.709,230.168 45.817,230.243 43.642,232.6C43.462,232.795 43.341,233.045 43.142,233.221C42.979,233.365 42.737,233.401 42.574,233.545C42.552,233.237 42.869,232.968 42.848,232.659C42.818,232.241 42.468,231.891 42.428,231.474C42.406,231.238 42.575,231.263 42.936,228.558C42.943,228.507 45.68,216.671 47.736,211.601C48.148,210.583 49.09,207.075 50.237,204.375C51.214,202.076 50.963,201.997 51.937,199.685C58.291,184.589 59.919,182.08 60.834,180.671C61.244,180.039 60.917,179.878 65.321,172.394C67.332,168.976 67.774,168.708 68.036,168.239C68.579,167.269 71.397,162.229 75.716,156.656C77.754,154.026 77.489,153.841 82.152,148.214C83.035,147.148 84.591,144.881 86.747,142.757C88.448,141.081 90.541,138.236 91.9,136.913C98.604,130.386 98.383,130.168 100.5,128.501C101.686,127.567 101.702,127.051 101.956,126.776C102.089,126.632 102.32,126.605 102.453,126.461C104.498,125.259 104.477,125.217 106.68,122.801C108.252,121.635 108.319,121.744 110.203,120.142C112.027,118.59 123.091,110.345 126.452,108.425C127.705,107.709 132.655,104.366 137.266,102.01C139.867,100.681 139.716,100.436 142.375,99.213C149.997,95.708 150.935,95.189 151.654,94.79C152.643,94.243 154.253,93.818 155.369,93.233C156.754,92.507 166.553,88.927 168.455,88.355C170.413,87.765 170.347,87.605 171.438,87.306C187.381,82.939 187.43,83.16 189.541,82.925C192.122,82.638 192.023,82.182 194.551,81.897C208.001,80.384 207.981,80.082 221.5,80.082C223.107,80.082 232.743,80.081 241.554,81.177C244.021,81.484 243.991,81.621 246.457,81.841C249.519,82.114 249.411,82.708 252.46,82.929C254.99,83.112 254.946,83.281 257.412,83.863C259.12,84.266 259.556,84.11 262.403,84.86C266.425,85.919 266.417,85.857 270.404,86.955Z', fill: 'LETTER_COLOR', transform: [1,0,0,1,27.951702,49.16518] },
    ],
  },
  {
    id: 3, name: 'Farfalla', icon: '🦋', type: 'svg', color: '#FFFFFF',
    svgViewBox: [0, 0, 500, 500],
    svgPaths: [{ d: 'M500.391,446.355C511.363,441.672 522.434,434.844 521.586,453.918C521.133,464.113 703.242,425.859 742.148,472.836C759.453,493.734 720.633,500.766 676.957,530.988C637.852,558.047 640.656,587.57 600.695,563.73C599.219,632.266 579.695,643.082 536.117,651.809C518.777,655.281 473.273,637.438 462.746,623.262C444.809,599.105 469.695,534.039 472.578,524.789C438.27,562.297 436.094,561.77 432.246,559.906C419.516,553.734 447.59,521.215 453.953,513.102C428.812,519.125 374.938,560.824 353.617,534.574C349.832,529.91 309.473,490.039 315.043,445.715C315.363,443.184 328.168,398.039 389.875,399.703C361.867,375.578 376.941,369.359 391.32,327.578C401.68,297.477 403.008,223.746 429.641,223.41C431.934,223.383 460.516,244.969 464.277,251.176C493.035,298.613 485.355,299.785 494.871,353C503.902,403.508 500.652,439.488 500.699,445.273', fill: '#FFFFFF', transform: [0.87795, 0, 0, 0.87795, -203.698467, -134.391682] }],
  },
  {
    id: 4, name: 'Nuvoletta', icon: '☁️', type: 'svg', color: '#FFFFFF',
    svgViewBox: [0, 0, 184, 115],
    svgPaths: [
      { d: 'M508.035,295.928C468.629,291.748 461.918,357.497 524.564,340.629C548.767,365.762 571.554,363.51 593.368,342.481C666.673,369.377 688.532,264.576 617.645,280.122C615.341,241.474 560.131,225.097 543.554,275.434C522.656,272.626 509.91,278.493 508.035,295.928Z', fill: '#FFFFFF', transform: [1,0,0,1,-477.941,-243.95] },
    ],
  },
  {
    id: 5, name: 'Mongolfiera', icon: '🎈', type: 'svg',
    svgViewBox: [0, 0, 864, 1184],
    // giallo → bianco; grigio → grigio chiaro
    svgPaths: [
      { d: 'M525.5,767.5C526.71,767.932 527.71,768.599 528.5,769.5C523.577,780.935 519.243,792.602 515.5,804.5C513.001,831.826 510.667,859.159 508.5,886.5C519.331,889.161 522.331,895.495 517.5,905.5C515.948,908.112 513.614,909.445 510.5,909.5C510.07,933.514 509.236,957.514 508,981.5C506.607,998.887 497.44,1009.39 480.5,1013C450.5,1013.67 420.5,1013.67 390.5,1013C372.954,1009.79 363.454,999.287 362,981.5C361.371,957.487 360.537,933.487 359.5,909.5C353.193,908.354 349.86,904.521 349.5,898C350.228,892.372 353.228,888.539 358.5,886.5L359.5,882C357.065,865.138 350.492,807.328 349.5,807.5C344.688,795.058 339.688,782.724 334.5,770.5C335.687,768.025 337.687,767.025 340.5,767.5C345.875,767.828 351.208,767.495 356.5,766.5C356.376,765.893 356.043,765.56 355.5,765.5C347.521,749.541 339.021,733.874 330,718.5C297.701,670.461 269.034,620.128 244,567.5C210.617,489.434 200.283,408.434 213,324.5C227.719,262.035 257.219,208.035 301.5,162.5C320.385,155.323 339.718,149.656 359.5,145.5C329.346,183.812 308.179,226.812 296,274.5C281.856,331.099 277.522,388.432 283,446.5C286.834,487.829 294.168,528.496 305,568.5C325.886,635.764 349.72,701.931 376.5,767C388.162,767.5 399.829,767.667 411.5,767.5C398.445,690.725 386.945,613.725 377,536.5C367.868,452.646 366.202,368.646 372,284.5C375.267,245.165 383.267,206.831 396,169.5C400.317,158.869 405.15,148.535 410.5,138.5C416.419,136.955 422.586,136.289 429,136.5C433.913,136.526 438.746,136.859 443.5,137.5C465.958,167.995 480.791,201.995 488,239.5C501.125,305.91 505.458,372.91 501,440.5C497.326,507.565 489.993,574.232 479,640.5C471.712,682.895 464.212,725.229 456.5,767.5C466.416,767.819 476.25,767.486 486,766.5L536,648.5C558.576,591.613 574.576,532.946 584,472.5C596.968,391.547 589.635,312.547 562,235.5C549.85,203.514 533.35,174.181 512.5,147.5C528.528,150.954 544.195,155.621 559.5,161.5C595.774,190.346 622.607,226.346 640,269.5C668.062,344.128 671.062,419.795 649,496.5C637.067,537.032 620.733,575.699 600,612.5C569.304,662.55 540.137,713.55 512.5,765.5L525.5,767.5ZM392.5,810.5L356.5,810.5C358.67,829.863 361.004,849.197 363.5,868.5C363.851,872.684 364.518,876.684 365.5,880.5L365.5,886.5L399.5,886.5C397.331,861.151 394.998,835.817 392.5,810.5ZM509.5,810.5L475.5,810.5C473.43,835.862 471.097,861.196 468.5,886.5L502.5,886.5C504.702,861.151 507.035,835.818 509.5,810.5ZM469.5,810.5L397.5,810.5C400.562,835.781 403.228,861.115 405.5,886.5L462.5,886.5C464.702,861.149 467.035,835.815 469.5,810.5Z', fill: '#FFFFFF' },
      { d: 'M410.5,138.5C405.15,148.535 400.317,158.869 396,169.5C383.267,206.831 375.267,245.165 372,284.5C366.202,368.646 367.868,452.646 377,536.5C386.945,613.725 398.445,690.725 411.5,767.5C399.829,767.667 388.162,767.5 376.5,767C349.72,701.931 325.886,635.764 305,568.5C294.168,528.496 286.834,487.829 283,446.5C277.522,388.432 281.856,331.099 296,274.5C308.179,226.812 329.346,183.812 359.5,145.5C376.222,141.223 393.222,138.89 410.5,138.5Z', fill: '#C8C8C8' },
      { d: 'M443.5,137.5C466.91,138.3 489.91,141.634 512.5,147.5C533.35,174.181 549.85,203.514 562,235.5C589.635,312.547 596.968,391.547 584,472.5C574.576,532.946 558.576,591.613 536,648.5C519.333,687.833 502.667,727.167 486,766.5C476.25,767.486 466.416,767.819 456.5,767.5C464.212,725.229 471.712,682.895 479,640.5C489.993,574.232 497.326,507.565 501,440.5C505.458,372.91 501.125,305.91 488,239.5C480.791,201.995 465.958,167.995 443.5,137.5Z', fill: '#C8C8C8' },
      { d: 'M340.5,767.5C337.687,767.025 335.687,768.025 334.5,770.5C322.005,752.823 308.505,735.823 294,719.5C260.791,687.634 229.791,653.968 201,618.5C171.332,579.17 148.999,535.837 134,488.5C99.921,355.649 141.088,253.816 257.5,183C271.604,174.912 286.271,168.079 301.5,162.5C257.219,208.035 227.719,262.035 213,324.5C200.283,408.434 210.617,489.434 244,567.5C269.034,620.128 297.701,670.461 330,718.5C339.021,733.874 347.521,749.541 355.5,765.5C356.043,765.56 356.376,765.893 356.5,766.5C351.208,767.495 345.875,767.828 340.5,767.5Z', fill: '#C8C8C8' },
      { d: 'M559.5,161.5C621.05,183.335 669.883,221.335 706,275.5C723.6,303.466 734.766,333.799 739.5,366.5C739.527,372.051 740.194,377.384 741.5,382.5C744.223,425.032 737.389,466.032 721,505.5C702.081,549.365 678.081,590.032 649,627.5C619.451,663.389 588.784,698.389 557,732.5C547.254,744.733 537.754,757.067 528.5,769.5C527.71,768.599 526.71,767.932 525.5,767.5C521.167,766.833 516.833,766.167 512.5,765.5C540.137,713.55 569.304,662.55 600,612.5C620.733,575.699 637.067,537.032 649,496.5C671.062,419.795 668.062,344.128 640,269.5C622.607,226.346 595.774,190.346 559.5,161.5Z', fill: '#C8C8C8' },
    ],
  },
  {
    id: 6, name: 'Cuore', icon: '❤️', type: 'svg', color: '#FFFFFF',
    svgViewBox: [0, 0, 1125, 1125],
    svgPaths: [
      { d: 'M 832.699219 596.734375 C 735.5 714.78125 562.085938 821.082031 562.085938 821.082031 C 562.085938 821.082031 391.582031 721.046875 296.066406 596.734375 C 129.109375 379.429688 402.46875 158.933594 562.085938 357.269531 C 743.46875 145.277344 996.074219 398.320312 832.699219 596.734375', fill: '#FFFFFF' },
    ],
  },
  {
    id: 7, name: 'Stella', icon: '⭐', type: 'svg', color: '#FFFFFF',
    svgViewBox: [0, 0, 1125, 1125],
    svgPaths: [
      { d: 'M 773.738281 679.308594 C 768.679688 653.824219 779.253906 617.617188 797.234375 598.867188 L 916.121094 474.898438 C 934.113281 456.144531 927.957031 436.734375 902.441406 431.769531 L 727.929688 397.828125 C 702.417969 392.867188 671.554688 370.039062 659.335938 347.101562 L 585.386719 208.230469 C 573.175781 185.296875 553.128906 185.269531 540.84375 208.164062 L 466.292969 347.171875 C 454.007812 370.070312 423.09375 392.871094 397.578125 397.832031 L 223.066406 431.769531 C 197.554688 436.734375 191.402344 456.140625 209.382812 474.898438 L 328.28125 598.867188 C 346.265625 617.625 357.410156 653.929688 353.039062 679.546875 L 325.773438 839.246094 C 321.402344 864.863281 336.820312 876.261719 360.042969 864.585938 L 520.550781 783.847656 C 543.765625 772.171875 581.863281 771.953125 605.214844 783.371094 L 772.320312 865.070312 C 795.664062 876.480469 810.628906 864.972656 805.558594 839.484375 Z', fill: '#FFFFFF' },
    ],
  },
];

/*
  Posizioni decorazioni: { x%, y%, w%, h% } relativi al canvas 760×760.
  Da compilare per ogni combinazione lettera × decorazione.
  Finché non configurata, usa DEFAULT_DECORATION_POS.
*/
/*
  Chiave posizione:
  - Solo:        'LETTERA_DECID'              es. 'A_3'
  - Combinata:   'LETTERA_ID1+ID2_DECID'      es. 'A_4+5_5'
                 (IDs sempre in ordine crescente)
*/
const DECORATION_POSITIONS = {
  'A_1': { x: 63.9, y: 56.8, w: 34.4, h: 30.3 },
  'A_2': { x: 54.5, y: 58.2, w: 52.4, h: 37.6 },
  'A_3': { x: 41.6, y: -0.8, w: 24, h: 24 },
  'A_4': { x: 47.9, y: 6.8, w: 11.6, h: 10.3 },
  'A_5': { x: 41.9, y: -4.4, w: 24.4, h: 32.6 },
  'A_6': { x: 43.2, y: 2.6, w: 18, h: 16 },
  'A_7': { x: 42.4, y: -1.1, w: 18, h: 18 },
  'A_1+4+5_1': { x: 66.8, y: 58.7, w: 28, h: 28 },
  'A_1+4+5_5': { x: 39.5, y: -3.7, w: 26, h: 36 },
  'A_1+4+5_4': { x: 34, y: 11.5, w: 9, h: 9 },
  'A_4+5_5': { x: 39.5, y: -3.7, w: 26, h: 36 },
  'A_4+5_4': { x: 34, y: 11.5, w: 9, h: 9 },
  'A_1+2_1': { x: 65, y: 59.2, w: 28, h: 28 },
  'A_1+2_2': { x: -17.3, y: 61.1, w: 54.5, h: 33.2 },
  'A_2+3_2': { x: 53.8, y: 61.4, w: 54.5, h: 33.2 },
  'A_2+3_3': { x: 42.9, y: 1.6, w: 24, h: 24 },
  'A_2+7_2': { x: 53.8, y: 61.4, w: 54.5, h: 33.2 },
  'A_2+7_7': { x: 42.9, y: 0, w: 18, h: 18 },
  'A_2+6_2': { x: 53.8, y: 61.4, w: 54.5, h: 33.2 },
  'A_2+6_6': { x: 40.8, y: 0, w: 22.7, h: 22.3 },
  'A_6+7_6': { x: 66.1, y: 64.5, w: 22.7, h: 22.3 },
  'A_6+7_7': { x: 42.1, y: -1.4, w: 18, h: 18 },
  'B_1': { x: 2.3, y: 59.5, w: 28, h: 28 },
  'B_2': { x: 1.8, y: 62.9, w: 33.4, h: 31 },
  'B_3': { x: 57.4, y: -2.6, w: 24, h: 24 },
  'B_4': { x: 64.7, y: 4.7, w: 11.4, h: 12.7 },
  'B_5': { x: 7.4, y: -6.1, w: 26, h: 36 },
  'B_6': { x: 54.7, y: -0.8, w: 24.1, h: 22.3 },
  'B_7': { x: 57.9, y: 0.5, w: 18, h: 18 },
  'B_1+4+5_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'B_1+4+5_5': { x: 58.9, y: -4.5, w: 23.9, h: 34.2 },
  'B_1+4+5_4': { x: 55.3, y: 14.5, w: 9, h: 9 },
  'B_4+5_5': { x: 53.4, y: -6.9, w: 26, h: 36 },
  'B_4+5_4': { x: 70, y: 13.1, w: 10.8, h: 9.8 },
  'B_1+7_1': { x: 4.2, y: 59.2, w: 28, h: 28 },
  'B_1+7_7': { x: 59.7, y: 1.1, w: 18, h: 18 },
  'B_1+6_1': { x: 4.2, y: 59.2, w: 28, h: 28 },
  'B_1+6_6': { x: 60.8, y: 2.6, w: 20.1, h: 19.9 },
  'B_1+3_1': { x: 4.2, y: 59.2, w: 28, h: 28 },
  'B_1+3_3': { x: 57.1, y: -2.9, w: 24, h: 24 },
  'C_1': { x: 7.4, y: 57.1, w: 29.8, h: 30.1 },
  'C_2': { x: 56.8, y: 60.5, w: 31.8, h: 37.6 },
  'C_3': { x: 62.4, y: 0, w: 24, h: 24 },
  'C_4': { x: 70.3, y: 8.4, w: 12.9, h: 11.9 },
  'C_5': { x: 8.7, y: 0, w: 26, h: 36 },
  'C_6': { x: 65.3, y: 5.5, w: 20.1, h: 19.4 },
  'C_7': { x: 66.8, y: 1.8, w: 18, h: 18 },
  'C_4+5_4': { x: 32.6, y: 14.7, w: 9, h: 9 },
  'C_4+5_5': { x: 10.8, y: -0.8, w: 26, h: 36 },
  'C_1+4+5_4': { x: 61.3, y: 13.7, w: 10.6, h: 10.6 },
  'C_1+4+5_5': { x: 64.2, y: -2.9, w: 26, h: 36 },
  'C_1+4+5_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'C_2+4_2': { x: 56.8, y: 63.4, w: 34.7, h: 31.1 },
  'C_2+4_4': { x: 20, y: 9.5, w: 12.2, h: 11.4 },
  'C_2+6_2': { x: 56.8, y: 63.4, w: 34.7, h: 31.1 },
  'C_2+6_6': { x: 17.1, y: 4.5, w: 22.2, h: 19.9 },
  'C_2+7_2': { x: 56.8, y: 63.4, w: 34.7, h: 31.1 },
  'C_2+7_7': { x: 19.2, y: 4.2, w: 18, h: 18 },
  'C_2+5_2': { x: 56.8, y: 63.4, w: 34.7, h: 31.1 },
  'C_2+5_5': { x: 10.5, y: -1.1, w: 26, h: 36 },
  'C_2+4+5_2': { x: 56.8, y: 63.4, w: 34.7, h: 31.1 },
  'C_2+4+5_5': { x: 10.5, y: -1.1, w: 26, h: 36 },
  'C_2+4+5_4': { x: 30.8, y: 14.8, w: 10.3, h: 9.5 },
  'C_4+5+6_6': { x: 65, y: 64.7, w: 23.8, h: 20.7 },
  'C_4+5+6_4': { x: 30.5, y: 15.5, w: 10.9, h: 12.1 },
  'C_4+5+6_5': { x: 11, y: -0.5, w: 26, h: 36 },
  'C_4+5+7_4': { x: 30.5, y: 15.5, w: 10.9, h: 12.1 },
  'C_4+5+7_5': { x: 11, y: -0.5, w: 26, h: 36 },
  'C_4+5+7_7': { x: 67.1, y: 61.5, w: 20.4, h: 19.8 },
  'C_3+4+5_4': { x: 30.5, y: 15.5, w: 10.9, h: 12.1 },
  'C_3+4+5_5': { x: 11, y: -0.5, w: 26, h: 36 },
  'C_3+4+5_3': { x: 65.3, y: 59.7, w: 24, h: 24 },
  'D_1': { x: -0.8, y: 56.6, w: 31.9, h: 31.4 },
  'D_1+2_1': { x: 59.9, y: 57.9, w: 31.9, h: 31.4 },
  'D_1+2_2': { x: -0.2, y: 61.5, w: 32.4, h: 32.4 },
  'D_1+4_1': { x: 59.9, y: 57.9, w: 31.9, h: 31.4 },
  'D_1+4_4': { x: 10.8, y: 14.2, w: 12.2, h: 11.1 },
  'D_1+4+5_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'D_1+4+5_4': { x: 58.4, y: 13.2, w: 11.1, h: 11.4 },
  'D_1+4+5_5': { x: 62.9, y: -4.2, w: 26, h: 36 },
  'D_4+5_4': { x: 25.8, y: 11.9, w: 12.2, h: 11.1 },
  'D_4+5_5': { x: 6.3, y: -4.5, w: 26, h: 36 },
  'D_2+4+5_4': { x: 25.8, y: 11.9, w: 12.2, h: 11.1 },
  'D_2+4+5_5': { x: 6.3, y: -4.5, w: 26, h: 36 },
  'D_2+4+5_2': { x: 50.8, y: 62.6, w: 36.1, h: 33.2 },
  'D_3': { x: 59.5, y: 0, w: 24, h: 24 },
  'D_7': { x: 57.9, y: 0.5, w: 20.9, h: 20.4 },
  'D_6': { x: 54.7, y: 0, w: 25.4, h: 23.4 },
  'D_1+7_1': { x: 0.5, y: 57.1, w: 29.8, h: 29.8 },
  'D_1+7_7': { x: 59.7, y: 2.4, w: 18, h: 18 },
  'D_1+6_1': { x: 0.5, y: 57.1, w: 29.8, h: 29.8 },
  'D_1+6_6': { x: 56.8, y: 1.3, w: 23.3, h: 21.5 },
  'D_1+3_1': { x: 0.5, y: 57.1, w: 29.8, h: 29.8 },
  'D_1+3_3': { x: 58.4, y: 0.8, w: 24, h: 24 },
  'D_1+3+6_1': { x: 0.5, y: 57.1, w: 29.8, h: 29.8 },
  'D_1+3+6_3': { x: 58.4, y: 0.8, w: 24, h: 24 },
  'D_1+3+6_6': { x: 60.8, y: 63.9, w: 25.4, h: 24.7 },
  'E_1': { x: 1.6, y: 54.5, w: 31.9, h: 33.3 },
  'E_1+4_1': { x: 1.6, y: 54.5, w: 31.9, h: 33.3 },
  'E_1+4_4': { x: 69.5, y: 5.8, w: 11.6, h: 11.1 },
  'E_1+4+5_1': { x: 1.6, y: 54.5, w: 31.9, h: 33.3 },
  'E_1+4+5_4': { x: 55.3, y: 9.2, w: 11.6, h: 11.1 },
  'E_1+4+5_5': { x: 62.7, y: -4.7, w: 26, h: 36 },
  'E_1+6_1': { x: 1.6, y: 54.5, w: 31.9, h: 33.3 },
  'E_1+6_6': { x: 63.2, y: 0.8, w: 21.9, h: 19.9 },
  'E_1+7_1': { x: 1.6, y: 54.5, w: 31.9, h: 33.3 },
  'E_1+7_7': { x: 63.9, y: -1.3, w: 20.6, h: 20.9 },
  'E_4': { x: 69.2, y: 6.8, w: 12.2, h: 11.6 },
  'E_4+5_4': { x: 31.6, y: 12.3, w: 12.2, h: 11.6 },
  'E_4+5_5': { x: 8.4, y: -3.9, w: 26, h: 36 },
  'E_6': { x: 61.1, y: 0, w: 24.8, h: 21.5 },
  'E_7': { x: 63.2, y: -0.8, w: 21.7, h: 20.9 },
  'E_3': { x: 61.1, y: -2.4, w: 24, h: 24 },
  'E_2+3_3': { x: 61.1, y: -2.4, w: 24, h: 24 },
  'E_2+3_2': { x: -4.2, y: 63.4, w: 45, h: 30.3 },
  'E_2+7_2': { x: -4.2, y: 63.4, w: 45, h: 30.3 },
  'E_2+7_7': { x: 61.1, y: -1.1, w: 23.3, h: 21.4 },
  'E_2+6_2': { x: -4.2, y: 63.4, w: 45, h: 30.3 },
  'E_2+6_6': { x: 61.1, y: -0.8, w: 23.5, h: 20.2 },
  'E_2+4_2': { x: -4.2, y: 63.4, w: 45, h: 30.3 },
  'E_2+4_4': { x: 69.7, y: 5.8, w: 12.4, h: 10.3 },
  'E_2+5_2': { x: -4.2, y: 63.4, w: 45, h: 30.3 },
  'E_2+5_5': { x: 63.2, y: -3.7, w: 26, h: 36 },
  'F_1': { x: 9.2, y: 54.5, w: 34.6, h: 32.5 },
  'F_1+3_1': { x: 9.2, y: 54.5, w: 34.6, h: 32.5 },
  'F_1+3_3': { x: 66.6, y: -1.3, w: 24, h: 24 },
  'F_1+4_1': { x: 9.2, y: 54.5, w: 34.6, h: 32.5 },
  'F_1+4_4': { x: 76.6, y: 6.6, w: 11.1, h: 10.3 },
  'F_1+4+5_1': { x: 9.2, y: 54.5, w: 34.6, h: 32.5 },
  'F_1+4+5_4': { x: 65, y: 11, w: 11.1, h: 10.3 },
  'F_1+4+5_5': { x: 69.2, y: -5, w: 26, h: 36 },
  'F_1+5_1': { x: 9.2, y: 54.5, w: 34.6, h: 32.5 },
  'F_1+5_5': { x: 69.2, y: -5, w: 26, h: 36 },
  'F_1+6_1': { x: 9.2, y: 54.5, w: 34.6, h: 32.5 },
  'F_1+6_6': { x: 68.9, y: 0.8, w: 24.6, h: 22.6 },
  'F_1+7_1': { x: 9.2, y: 54.5, w: 34.6, h: 32.5 },
  'F_1+7_7': { x: 72.4, y: 1.3, w: 19.8, h: 19.6 },
  'F_4': { x: 76.1, y: 8.2, w: 11.9, h: 9.3 },
  'F_4+5_4': { x: 38.2, y: 13.5, w: 11.9, h: 9.3 },
  'F_4+5_5': { x: 15.8, y: -3.9, w: 26, h: 36 },
  'F_3': { x: 67.9, y: -1.3, w: 24, h: 24 },
  'F_7': { x: 71.4, y: -0.5, w: 19.3, h: 20.1 },
  'F_6': { x: 66.8, y: -0.5, w: 27.2, h: 24.7 },
  'F_2': { x: 5.5, y: 58.9, w: 39.5, h: 36.1 },
  'F_2+6_2': { x: 5.5, y: 58.9, w: 39.5, h: 36.1 },
  'F_2+6_6': { x: 70, y: 0.5, w: 23, h: 23.4 },
  'F_2+7_2': { x: 5.5, y: 58.9, w: 39.5, h: 36.1 },
  'F_2+7_7': { x: 70.5, y: -0.8, w: 24.6, h: 24.3 },
  'F_2+4_2': { x: 5.5, y: 58.9, w: 39.5, h: 36.1 },
  'F_2+4_4': { x: 76.3, y: 6.1, w: 12.2, h: 11.4 },
  'F_2+3_2': { x: 5.5, y: 58.9, w: 39.5, h: 36.1 },
  'F_2+3_3': { x: 67.4, y: -2.1, w: 24, h: 24 },
  'F_2+5_2': { x: 5.5, y: 58.9, w: 39.5, h: 36.1 },
  'F_2+5_5': { x: 69.2, y: -4.5, w: 26, h: 36 },
  'G_1': { x: 1.8, y: 56.4, w: 30.6, h: 31.2 },
  'G_1+4_1': { x: 1.8, y: 56.4, w: 30.6, h: 31.2 },
  'G_1+4_4': { x: 69.5, y: 9.5, w: 11.1, h: 11.1 },
  'G_1+4+5_1': { x: 1.8, y: 56.4, w: 30.6, h: 31.2 },
  'G_1+4+5_4': { x: 58.2, y: 14.8, w: 11.1, h: 11.1 },
  'G_1+4+5_5': { x: 62.9, y: -1.9, w: 26, h: 36 },
  'G_1+5_1': { x: 1.8, y: 56.4, w: 30.6, h: 31.2 },
  'G_1+5_5': { x: 62.9, y: -1.9, w: 26, h: 36 },
  'G_1+6_1': { x: 1.8, y: 56.4, w: 30.6, h: 31.2 },
  'G_1+6_6': { x: 62.1, y: 4.2, w: 24.3, h: 22.6 },
  'G_1+7_1': { x: 1.8, y: 56.4, w: 30.6, h: 31.2 },
  'G_1+7_7': { x: 64.2, y: 1.3, w: 20.6, h: 20.6 },
  'G_3': { x: 60.3, y: 0.5, w: 24, h: 24 },
  'G_5': { x: 61.8, y: -3.7, w: 26, h: 36 },
  'G_6': { x: 61.8, y: 2.4, w: 22.7, h: 21.3 },
  'G_7': { x: 61.6, y: 0, w: 24.3, h: 24.1 },
  'G_2': { x: 5.8, y: 59.5, w: 33.9, h: 38.2 },
  'G_1+2_2': { x: 59.7, y: 59, w: 33.9, h: 38.2 },
  'G_1+2_1': { x: 2.6, y: 53.9, w: 34.3, h: 37.2 },
  'G_1+2+4_2': { x: 59.7, y: 59, w: 33.9, h: 38.2 },
  'G_1+2+4_1': { x: 2.6, y: 53.9, w: 34.3, h: 37.2 },
  'G_1+2+4_4': { x: 67.9, y: 9.2, w: 11.9, h: 11.9 },
  'G_2+4_2': { x: 59.7, y: 59, w: 33.9, h: 38.2 },
  'G_2+4_4': { x: 14.5, y: 11.3, w: 10.8, h: 10.6 },
  'G_2+7_2': { x: 59.7, y: 59, w: 33.9, h: 38.2 },
  'G_2+7_7': { x: 18.7, y: 1.9, w: 18, h: 18 },
  'G_2+6_2': { x: 59.7, y: 59, w: 33.9, h: 38.2 },
  'G_2+6_6': { x: 15.5, y: 0.2, w: 23.8, h: 21.3 },
  'H_1': { x: 62.6, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+2_1': { x: 62.6, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+2_2': { x: -1.1, y: 60.8, w: 33.7, h: 33.2 },
  'H_1+3_1': { x: -1.9, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+3_3': { x: 66.1, y: -3.9, w: 24, h: 24 },
  'H_1+4_1': { x: -1.9, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+4_4': { x: 73.4, y: 7.1, w: 12.7, h: 11.6 },
  'H_1+4+5_1': { x: -1.9, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+4+5_4': { x: 55, y: 10.8, w: 12.7, h: 11.6 },
  'H_1+4+5_5': { x: 62.6, y: -5.1, w: 26, h: 36 },
  'H_1+5_1': { x: -1.9, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+5_5': { x: 62.6, y: -5.1, w: 26, h: 36 },
  'H_1+6_1': { x: -1.9, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+6_6': { x: 67.1, y: -4.4, w: 25.9, h: 28.9 },
  'H_1+7_1': { x: -1.9, y: 52.1, w: 34.1, h: 36.9 },
  'H_1+7_7': { x: 67.1, y: -1.8, w: 23.8, h: 22.5 },
  'H_7': { x: 67.1, y: -1.8, w: 23.8, h: 22.5 },
  'H_6': { x: 65.3, y: -2.9, w: 25.6, h: 27.8 },
  'H_5': { x: 63.2, y: -5.5, w: 26, h: 36 },
  'H_4+5_5': { x: 63.2, y: -5.5, w: 26, h: 36 },
  'H_4+5_4': { x: 56.6, y: 10.7, w: 11.6, h: 11.9 },
  'H_3': { x: 64.7, y: -1.8, w: 24, h: 24 },
  'H_2': { x: 60.3, y: 58.7, w: 31.8, h: 38.2 },
  'H_2+6_2': { x: 60.3, y: 58.7, w: 31.8, h: 38.2 },
  'H_2+6_6': { x: 5.8, y: 0, w: 26.7, h: 25.5 },
  'H_2+7_2': { x: 60.3, y: 58.7, w: 31.8, h: 38.2 },
  'H_2+7_7': { x: 8.9, y: -1, w: 21.7, h: 23.3 },
  'H_2+4+5_2': { x: 60.3, y: 58.7, w: 31.8, h: 38.2 },
  'H_2+4+5_4': { x: 27.3, y: 12.1, w: 11.1, h: 11.1 },
  'H_2+4+5_5': { x: 3.7, y: -5.8, w: 26, h: 36 },
  'H_2+5_2': { x: 60.3, y: 58.7, w: 31.8, h: 38.2 },
  'H_2+5_5': { x: 3.7, y: -5.8, w: 26, h: 36 },
  'I_1': { x: 44.5, y: 52.1, w: 31.2, h: 38.5 },
  'I_1+3_1': { x: 18.7, y: 52.6, w: 31.2, h: 38.5 },
  'I_1+3_3': { x: 46.1, y: -1.8, w: 24, h: 24 },
  'I_1+4_1': { x: 18.7, y: 52.6, w: 31.2, h: 38.5 },
  'I_1+4_4': { x: 51.6, y: 5, w: 12.4, h: 12.9 },
  'I_1+5_1': { x: 18.7, y: 52.6, w: 31.2, h: 38.5 },
  'I_1+5_5': { x: 45.3, y: -4.2, w: 24.9, h: 34.7 },
  'I_1+4+5_1': { x: 18.7, y: 52.6, w: 31.2, h: 38.5 },
  'I_1+4+5_5': { x: 45.3, y: -4.2, w: 24.9, h: 34.7 },
  'I_1+4+5_4': { x: 34.7, y: 10.5, w: 10.6, h: 10.6 },
  'I_1+6_1': { x: 18.7, y: 52.6, w: 31.2, h: 38.5 },
  'I_1+6_6': { x: 46.3, y: 0.8, w: 23, h: 23.9 },
  'I_1+7_1': { x: 18.7, y: 52.6, w: 31.2, h: 38.5 },
  'I_1+7_7': { x: 48.4, y: 0.3, w: 23.5, h: 24.6 },
  'I_7': { x: 48.4, y: 0.3, w: 23.5, h: 24.6 },
  'I_6': { x: 46.8, y: 0.8, w: 23.3, h: 23.4 },
  'I_5': { x: 45.5, y: -3.9, w: 26, h: 36 },
  'I_4+5_5': { x: 46, y: -5.2, w: 26, h: 36 },
  'I_4+5_4': { x: 35, y: 10.8, w: 11.4, h: 11.9 },
  'I_4': { x: 50.5, y: 6.8, w: 12.4, h: 13.2 },
  'I_3': { x: 46.3, y: -1.6, w: 24, h: 24 },
  'I_2': { x: 35.5, y: 58.4, w: 44.5, h: 37.4 },
  'I_2+4_2': { x: 35.5, y: 58.4, w: 44.5, h: 37.4 },
  'I_2+4_4': { x: 30.5, y: 8.2, w: 13.2, h: 13.7 },
  'I_2+4+5_2': { x: 35.5, y: 58.4, w: 44.5, h: 37.4 },
  'I_2+4+5_4': { x: 30.5, y: 8.2, w: 13.2, h: 13.7 },
  'I_2+4+5_5': { x: 40, y: -7.9, w: 29.5, h: 41 },
  'I_2+5_2': { x: 35.5, y: 58.4, w: 44.5, h: 37.4 },
  'I_2+5_5': { x: 23.4, y: -7.6, w: 29.5, h: 41 },
  'I_2+6_2': { x: 35.5, y: 58.4, w: 44.5, h: 37.4 },
  'I_2+6_6': { x: 28.2, y: 2.1, w: 23.8, h: 21.3 },
  'I_2+7_2': { x: 35.5, y: 58.4, w: 44.5, h: 37.4 },
  'I_2+7_7': { x: 29.2, y: 1.8, w: 21.9, h: 25.1 },
  'L_2': { x: -1.6, y: 58.4, w: 44.5, h: 37.4 },
  'L_2+3_2': { x: -1.6, y: 58.4, w: 44.5, h: 37.4 },
  'L_2+3_3': { x: 30.8, y: -1.1, w: 24, h: 24 },
  'L_2+4_2': { x: -1.6, y: 58.4, w: 44.5, h: 37.4 },
  'L_2+4_4': { x: 34.7, y: 7.1, w: 12.4, h: 12.2 },
  'L_2+5_2': { x: -1.6, y: 58.4, w: 44.5, h: 37.4 },
  'L_2+5_5': { x: 29.5, y: -3.7, w: 26, h: 36 },
  'L_2+4+5_2': { x: -1.6, y: 58.4, w: 44.5, h: 37.4 },
  'L_2+4+5_5': { x: 29.5, y: -3.7, w: 26, h: 36 },
  'L_2+4+5_4': { x: 19.5, y: 14.5, w: 10.8, h: 10.1 },
  'L_2+6_2': { x: -1.6, y: 58.4, w: 44.5, h: 37.4 },
  'L_2+6_6': { x: 29.7, y: 2.1, w: 26.1, h: 26 },
  'L_2+7_2': { x: -1.6, y: 58.4, w: 44.5, h: 37.4 },
  'L_2+7_7': { x: 30.5, y: 1.3, w: 23.3, h: 24.6 },
  'L_7': { x: 30.5, y: 1.3, w: 23.3, h: 24.6 },
  'L_6': { x: 28.9, y: 0.8, w: 25.1, h: 25.7 },
  'L_5': { x: 9.5, y: -3.4, w: 26, h: 36 },
  'L_4': { x: 35.3, y: 7.9, w: 11.9, h: 12.4 },
  'L_4+5_4': { x: 33.2, y: 10.3, w: 11.9, h: 12.4 },
  'L_4+5_5': { x: 9.7, y: -4.8, w: 26, h: 36 },
  'L_3': { x: 28.7, y: -2.1, w: 24, h: 24 },
  'L_1': { x: 4.7, y: 53.7, w: 31.4, h: 35.6 },
  'L_1+7_1': { x: 4.7, y: 53.7, w: 31.4, h: 35.6 },
  'L_1+7_7': { x: 32.1, y: 2.1, w: 21.7, h: 22.7 },
  'L_1+6_1': { x: 4.7, y: 53.7, w: 31.4, h: 35.6 },
  'L_1+6_6': { x: 29.2, y: 0.5, w: 23.8, h: 25.5 },
  'L_1+5_1': { x: 4.7, y: 53.7, w: 31.4, h: 35.6 },
  'L_1+5_5': { x: 27.6, y: -5.8, w: 26, h: 36 },
  'L_1+4+5_1': { x: 4.7, y: 53.7, w: 31.4, h: 35.6 },
  'L_1+4+5_5': { x: 27.9, y: -4.5, w: 26, h: 36 },
  'L_1+4+5_4': { x: 20.3, y: 11.6, w: 10.8, h: 11.1 },
  'M_1': { x: 69.5, y: 50, w: 35.4, h: 41.4 },
  'M_1+5_1': { x: 69.5, y: 50, w: 35.4, h: 41.4 },
  'M_1+5_5': { x: -5.8, y: -5.3, w: 26, h: 36 },
  'M_1+4+5_1': { x: 69.5, y: 50, w: 35.4, h: 41.4 },
  'M_1+4+5_5': { x: -5.8, y: -5.3, w: 26, h: 36 },
  'M_1+4+5_4': { x: 15.5, y: 11.3, w: 11.6, h: 11.4 },
  'M_4+5_5': { x: 73.7, y: -5.8, w: 26, h: 36 },
  'M_4+5_4': { x: 66.6, y: 12.6, w: 11.6, h: 11.4 },
  'M_4': { x: 81.6, y: 8.9, w: 11.6, h: 11.4 },
  'M_6': { x: 74.5, y: 0.8, w: 24.8, h: 23.4 },
  'M_7': { x: 72.6, y: -1.3, w: 27.2, h: 24.8 },
  'M_1+6_1': { x: 71.6, y: 52.1, w: 34.1, h: 36.2 },
  'M_1+6_6': { x: -6.1, y: 0.3, w: 30.6, h: 26 },
  'M_1+7_1': { x: 71.6, y: 52.1, w: 34.1, h: 36.2 },
  'M_1+7_7': { x: -3.9, y: 0, w: 25.6, h: 25.9 },
  'M_1+3_1': { x: 71.6, y: 52.1, w: 34.1, h: 36.2 },
  'M_1+3_3': { x: -0.8, y: -3.2, w: 24, h: 24 },
  'M_3': { x: 74.5, y: -2.7, w: 24, h: 24 },
  'M_2': { x: 69.7, y: 57.4, w: 31.8, h: 39.5 },
  'M_2+3_2': { x: 69.7, y: 57.4, w: 31.8, h: 39.5 },
  'M_2+3_3': { x: -1.1, y: -2.9, w: 24, h: 24 },
  'N_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+3_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+3_3': { x: 9.5, y: -2.6, w: 24, h: 24 },
  'N_1+2_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+2_2': { x: -2.1, y: 57.4, w: 32.9, h: 39.2 },
  'N_1+4_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+4_4': { x: 11.3, y: 10.8, w: 10.8, h: 10.1 },
  'N_1+5_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+5_5': { x: 5.3, y: -5.3, w: 26, h: 36 },
  'N_1+4+5_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+4+5_5': { x: 5.3, y: -5.3, w: 26, h: 36 },
  'N_1+4+5_4': { x: 23.2, y: 13.4, w: 9, h: 9 },
  'N_1+6_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+6_6': { x: 6.1, y: 0.3, w: 24.3, h: 23.6 },
  'N_1+7_1': { x: 62.1, y: 55, w: 30.6, h: 33 },
  'N_1+7_7': { x: 5.5, y: -1.8, w: 23, h: 23 },
  'N_7': { x: 5.5, y: -1.8, w: 23, h: 23 },
  'N_6': { x: 6.8, y: 0, w: 23.8, h: 23.6 },
  'N_5': { x: 3.7, y: -5.5, w: 26, h: 36 },
  'N_4+5_5': { x: 3.7, y: -5.5, w: 26, h: 36 },
  'N_4+5_4': { x: 21.6, y: 13.7, w: 9, h: 9 },
  'N_4': { x: 12.1, y: 10, w: 11.1, h: 11.9 },
  'N_3': { x: 65.3, y: -2.9, w: 24, h: 24 },
  'N_2': { x: 60.5, y: 58.7, w: 31.1, h: 38.9 },
  'N_2+3_2': { x: 60.5, y: 58.7, w: 31.1, h: 38.9 },
  'N_2+3_3': { x: 10.5, y: -2.4, w: 24, h: 24 },
  'N_2+4_2': { x: 60.5, y: 58.7, w: 31.1, h: 38.9 },
  'N_2+4_4': { x: 12.9, y: 10.5, w: 10.8, h: 11.4 },
  'N_2+4+5_2': { x: 60.5, y: 58.7, w: 31.1, h: 38.9 },
  'N_2+4+5_4': { x: 22.6, y: 12.1, w: 10.8, h: 11.4 },
  'N_2+4+5_5': { x: 5.3, y: -4.7, w: 26, h: 36 },
  'N_2+6_2': { x: 60.5, y: 58.7, w: 31.1, h: 38.9 },
  'N_2+6_6': { x: 6.6, y: -0.3, w: 28, h: 25.7 },
  'N_2+7_2': { x: 60.5, y: 58.7, w: 31.1, h: 38.9 },
  'N_2+7_7': { x: 8.4, y: 1.8, w: 21.9, h: 23 },
  'O_1': { x: 5.3, y: 57.3, w: 30.1, h: 30.9 },
  'O_1+3_1': { x: 5.3, y: 57.3, w: 30.1, h: 30.9 },
  'O_1+3_3': { x: 58.5, y: 1.8, w: 24, h: 24 },
  'O_1+4_1': { x: 5.3, y: 57.3, w: 30.1, h: 30.9 },
  'O_1+4_4': { x: 65.8, y: 8.7, w: 10.8, h: 9.5 },
  'O_1+5_1': { x: 5.3, y: 57.3, w: 30.1, h: 30.9 },
  'O_1+5_5': { x: 61.8, y: -4, w: 26, h: 36 },
  'O_1+4+5_1': { x: 5.3, y: 57.3, w: 30.1, h: 30.9 },
  'O_1+4+5_5': { x: 61.8, y: -4, w: 26, h: 36 },
  'O_1+4+5_4': { x: 60.8, y: 13.9, w: 9, h: 9 },
  'O_1+6_1': { x: 5.3, y: 57.3, w: 30.1, h: 30.9 },
  'O_1+6_6': { x: 60.3, y: 5.5, w: 21.2, h: 19.9 },
  'O_1+7_1': { x: 5.3, y: 57.3, w: 30.1, h: 30.9 },
  'O_1+7_7': { x: 60.3, y: 3.4, w: 22.7, h: 21.4 },
  'O_3': { x: 58.2, y: 1.3, w: 24, h: 24 },
  'O_5': { x: 60.8, y: -3.4, w: 26, h: 36 },
  'O_4+5_5': { x: 60.8, y: -3.4, w: 26, h: 36 },
  'O_4+5_4': { x: 57.6, y: 14.2, w: 9, h: 9 },
  'O_6': { x: 58.4, y: 2.9, w: 23.8, h: 22.6 },
  'O_7': { x: 59.7, y: 3.1, w: 21.7, h: 21.9 },
  'O_2': { x: 48.7, y: 63.4, w: 32.1, h: 31.3 },
  'O_2+3_2': { x: 48.7, y: 63.4, w: 32.1, h: 31.3 },
  'O_2+3_3': { x: 20.5, y: -1.1, w: 24, h: 24 },
  'P_1': { x: 5.5, y: 56.3, w: 29.8, h: 32.2 },
  'P_1+3_1': { x: 5.5, y: 56.3, w: 29.8, h: 32.2 },
  'P_1+3_3': { x: 58.4, y: -1.1, w: 24, h: 24 },
  'P_1+4_1': { x: 5.5, y: 56.3, w: 29.8, h: 32.2 },
  'P_1+4_4': { x: 66.1, y: 6.3, w: 11.6, h: 10.3 },
  'P_1+4+5_1': { x: 5.5, y: 56.3, w: 29.8, h: 32.2 },
  'P_1+4+5_4': { x: 53.7, y: 11.6, w: 11.6, h: 10.3 },
  'P_1+4+5_5': { x: 58.7, y: -6.1, w: 26, h: 36 },
  'P_1+5_1': { x: 5.5, y: 56.3, w: 29.8, h: 32.2 },
  'P_1+5_5': { x: 60.3, y: -5.8, w: 26, h: 36 },
  'P_1+6_1': { x: 5.5, y: 56.3, w: 29.8, h: 32.2 },
  'P_1+6_6': { x: 59.2, y: 1.1, w: 22.2, h: 20.5 },
  'P_1+7_1': { x: 5.5, y: 56.3, w: 29.8, h: 32.2 },
  'P_1+7_7': { x: 59.2, y: -1.6, w: 20.4, h: 21.7 },
  'P_2': { x: 4.5, y: 56.1, w: 33.2, h: 42.6 },
  'P_3': { x: 56.3, y: -0.3, w: 24, h: 24 },
  'P_6': { x: 57.4, y: -0.8, w: 24.8, h: 25.3 },
  'Q_6': { x: 57.4, y: -0.8, w: 24.8, h: 25.3 },
  'Q_7': { x: 58.9, y: 0.6, w: 19.8, h: 21.7 },
  'R_1': { x: 1.8, y: 54.8, w: 32.2, h: 33.8 },
  'R_1+3_1': { x: 1.8, y: 54.8, w: 32.2, h: 33.8 },
  'R_1+3_3': { x: 55.5, y: -1.1, w: 24, h: 24 },
  'R_1+4_1': { x: 1.8, y: 54.8, w: 32.2, h: 33.8 },
  'R_1+4_4': { x: 64.7, y: 7.6, w: 10.6, h: 10.6 },
  'R_1+5_1': { x: 1.8, y: 54.8, w: 32.2, h: 33.8 },
  'R_1+5_5': { x: 58.7, y: -3.4, w: 24.2, h: 33.1 },
  'R_1+4+5_1': { x: 1.8, y: 54.8, w: 32.2, h: 33.8 },
  'R_1+4+5_5': { x: 58.7, y: -3.4, w: 24.2, h: 33.1 },
  'R_1+4+5_4': { x: 54.5, y: 14.2, w: 9, h: 9 },
  'R_1+6_1': { x: 1.8, y: 54.8, w: 32.2, h: 33.8 },
  'R_1+6_6': { x: 56.3, y: 0.8, w: 21.9, h: 20.5 },
  'R_1+7_1': { x: 1.8, y: 54.8, w: 32.2, h: 33.8 },
  'R_1+7_7': { x: 57.9, y: -1.1, w: 21.4, h: 22.7 },
  'R_7': { x: 57.9, y: -1.1, w: 21.4, h: 22.7 },
  'R_6': { x: 57.6, y: 1.1, w: 21.7, h: 20.5 },
  'R_5': { x: 5.8, y: -4.7, w: 26, h: 36 },
  'R_4+5_5': { x: 5.8, y: -4.7, w: 26, h: 36 },
  'R_4+5_4': { x: 30.8, y: 13.9, w: 9, h: 9 },
  'R_4': { x: 15, y: 12.4, w: 9, h: 9 },
  'R_3': { x: 55.3, y: -1.1, w: 24, h: 24 },
  'R_2': { x: 0.8, y: 58.6, w: 35.3, h: 36.1 },
  'R_1+2_2': { x: 0.8, y: 58.6, w: 35.3, h: 36.1 },
  'R_1+2_1': { x: 64, y: 51.6, w: 33.8, h: 39.3 },
  'S_1': { x: 61.9, y: 52.4, w: 33.8, h: 39.3 },
  'S_1+3_1': { x: 58.5, y: 52.9, w: 33.8, h: 39.3 },
  'S_1+3_3': { x: 13.7, y: 0, w: 24, h: 24 },
  'S_1+4_1': { x: 58.5, y: 52.9, w: 33.8, h: 39.3 },
  'S_1+4_4': { x: 18.7, y: 10.5, w: 9, h: 9 },
  'S_1+5_1': { x: 58.5, y: 52.9, w: 33.8, h: 39.3 },
  'S_1+5_5': { x: 7.9, y: -3.4, w: 26, h: 36 },
  'S_1+4+5_1': { x: 58.5, y: 52.9, w: 33.8, h: 39.3 },
  'S_1+4+5_5': { x: 7.9, y: -3.4, w: 26, h: 36 },
  'S_1+4+5_4': { x: 26.3, y: 15, w: 9, h: 9 },
  'S_4+5_5': { x: 7.9, y: -3.4, w: 26, h: 36 },
  'S_4+5_4': { x: 26.3, y: 15, w: 9, h: 9 },
  'S_5': { x: 8.4, y: -1.8, w: 26, h: 36 },
  'S_4': { x: 20.3, y: 8.2, w: 9, h: 9 },
  'S_6': { x: 58.4, y: 4.2, w: 23, h: 21.3 },
  'S_7': { x: 61.9, y: 1.9, w: 20.1, h: 20.4 },
  'T_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_2': { x: 41.1, y: 55, w: 38.2, h: 42.6 },
  'T_3': { x: 64.2, y: -2.6, w: 24, h: 24 },
  'T_4': { x: 74.5, y: 8.4, w: 9, h: 9 },
  'T_5': { x: 66.8, y: -2.9, w: 26, h: 36 },
  'T_4+5_5': { x: 66.8, y: -2.9, w: 26, h: 36 },
  'T_4+5_4': { x: 62.6, y: 10, w: 9, h: 9 },
  'T_6': { x: 64.2, y: -1.6, w: 25.4, h: 27.8 },
  'T_7': { x: 65, y: -2.7, w: 24.3, h: 27.5 },
  'U_1': { x: 3.7, y: 50, w: 35.4, h: 40.4 },
  'U_1+3_1': { x: 3.7, y: 50, w: 35.4, h: 40.4 },
  'U_1+3_3': { x: 64.5, y: -1.8, w: 24, h: 24 },
  'U_1+4_1': { x: 3.7, y: 50, w: 35.4, h: 40.4 },
  'U_1+4_4': { x: 72.4, y: 10.5, w: 9, h: 9 },
  'U_1+5_1': { x: 62.4, y: 48.9, w: 35.4, h: 40.4 },
  'U_1+5_5': { x: 5, y: -4.5, w: 26, h: 36 },
  'U_1+4+5_1': { x: 62.4, y: 48.9, w: 35.4, h: 40.4 },
  'U_1+4+5_5': { x: 5, y: -4.5, w: 26, h: 36 },
  'U_1+4+5_4': { x: 30.5, y: 12.4, w: 9, h: 9 },
  'U_1+6_1': { x: 3.5, y: 51.8, w: 35.4, h: 40.4 },
  'U_1+6_6': { x: 65.5, y: 1.8, w: 23.3, h: 24.4 },
  'U_1+7_1': { x: 3.5, y: 51.8, w: 35.4, h: 40.4 },
  'U_1+7_7': { x: 64.7, y: -0.3, w: 26.7, h: 24.1 },
  'U_7': { x: 64.7, y: -0.3, w: 26.7, h: 24.1 },
  'U_6': { x: 64.2, y: 1.6, w: 24.8, h: 24.4 },
  'U_5': { x: 5.5, y: -2.9, w: 26, h: 36 },
  'V_1': { x: 17.9, y: 47.1, w: 37, h: 45.9 },
  'V_1+3_3': { x: 67.9, y: -2.6, w: 24, h: 24 },
  'V_1+3_1': { x: 17.9, y: 47.1, w: 37, h: 45.9 },
  'V_1+4_1': { x: 17.9, y: 47.1, w: 37, h: 45.9 },
  'V_1+4_4': { x: 72.1, y: 9.2, w: 11.6, h: 11.4 },
  'V_1+5_1': { x: 17.9, y: 47.1, w: 37, h: 45.9 },
  'V_1+5_5': { x: 65, y: -5.8, w: 26, h: 36 },
  'V_1+4+5_1': { x: 17.9, y: 47.1, w: 37, h: 45.9 },
  'V_1+4+5_5': { x: 65, y: -5.8, w: 26, h: 36 },
  'V_1+4+5_4': { x: 61.3, y: 12.1, w: 10.6, h: 11.9 },
  'V_4+5_5': { x: 2.4, y: -7.6, w: 26, h: 36 },
  'V_4+5_4': { x: 20, y: 10, w: 10.6, h: 11.9 },
  'V_1+6_1': { x: 19, y: 53.5, w: 34.1, h: 34.6 },
  'V_1+6_6': { x: 66.3, y: -2.1, w: 27.5, h: 28.6 },
  'V_1+7_1': { x: 19, y: 53.5, w: 34.1, h: 34.6 },
  'V_1+7_7': { x: 67.1, y: -2.9, w: 24.6, h: 24.6 },
  'V_7': { x: 67.1, y: -2.9, w: 24.6, h: 24.6 },
  'V_6': { x: 66.8, y: -1.8, w: 25.4, h: 29.2 },
  'V_3': { x: 65.8, y: -4.2, w: 24, h: 24 },
  'V_2': { x: 18.2, y: 57.6, w: 37.1, h: 39.5 },
  'V_2+3_2': { x: 18.2, y: 57.6, w: 37.1, h: 39.5 },
  'V_2+3_3': { x: 67.1, y: -2.4, w: 24, h: 24 },
  'V_2+3+6_2': { x: 18.2, y: 57.6, w: 37.1, h: 39.5 },
  'V_2+3+6_3': { x: 67.1, y: -2.4, w: 24, h: 24 },
  'V_2+3+6_6': { x: 5, y: -5, w: 29.3, h: 29.9 },
  'V_2+6_2': { x: 18.2, y: 57.6, w: 37.1, h: 39.5 },
  'V_2+6_6': { x: 63.9, y: -3.4, w: 29.3, h: 29.9 },
  'V_2+7_2': { x: 18.2, y: 57.6, w: 37.1, h: 39.5 },
  'V_2+7_7': { x: 64.7, y: -3.2, w: 27.7, h: 25.6 },
  'J_2+7_2': { x: 46.4, y: 56.5, w: 37.1, h: 39.5 },
  'J_2+7_7': { x: 32.9, y: -6.1, w: 28.8, h: 29.3 },
  'J_2': { x: 46.4, y: 56.5, w: 37.1, h: 39.5 },
  'J_2+3_2': { x: 46.4, y: 56.5, w: 37.1, h: 39.5 },
  'J_2+3_3': { x: 38.7, y: -2.6, w: 24, h: 24 },
  'J_2+5_2': { x: 46.4, y: 56.5, w: 37.1, h: 39.5 },
  'J_2+5_5': { x: 33.9, y: -6.6, w: 26, h: 36 },
  'J_2+4+5_2': { x: 46.4, y: 56.5, w: 37.1, h: 39.5 },
  'J_2+4+5_5': { x: 33.9, y: -6.6, w: 26, h: 36 },
  'J_2+4+5_4': { x: 52.9, y: 11.8, w: 9, h: 9 },
  'J_2+6_2': { x: 46.4, y: 56.5, w: 37.1, h: 39.5 },
  'J_2+6_6': { x: 37.6, y: -1.9, w: 24.1, h: 26.3 },
  'J_7': { x: 32.9, y: -6.1, w: 28.8, h: 29.3 },
  'J_6': { x: 52.6, y: -3.4, w: 30.1, h: 28.6 },
  'J_5': { x: 55.8, y: -6.3, w: 26, h: 36 },
  'J_4+5_5': { x: 54.7, y: -5.2, w: 26, h: 36 },
  'J_4+5_4': { x: 46.6, y: 15.5, w: 9, h: 9 },
  'J_4': { x: 64.2, y: 11.8, w: 9, h: 9 },
  'J_3': { x: 55.8, y: -1.3, w: 24, h: 24 },
  'J_1': { x: 52.1, y: 51.3, w: 33.3, h: 35.6 },
  'J_1+3_1': { x: 52.1, y: 51.3, w: 33.3, h: 35.6 },
  'J_1+3_3': { x: 37.9, y: -2.1, w: 24, h: 24 },
  'J_1+4_1': { x: 52.1, y: 51.3, w: 33.3, h: 35.6 },
  'J_1+4_4': { x: 42.9, y: 11.8, w: 12.2, h: 13.7 },
  'J_1+5_1': { x: 52.1, y: 51.3, w: 33.3, h: 35.6 },
  'J_1+5_5': { x: 35.8, y: -4.2, w: 26, h: 36 },
  'J_1+4+5_1': { x: 52.1, y: 51.3, w: 33.3, h: 35.6 },
  'J_1+4+5_5': { x: 35.8, y: -4.2, w: 26, h: 36 },
  'J_1+4+5_4': { x: 54.5, y: 14.7, w: 9, h: 9 },
  'J_1+6_1': { x: 52.1, y: 51.3, w: 33.3, h: 35.6 },
  'J_1+6_6': { x: 35, y: -1.3, w: 24.1, h: 24.4 },
  'J_1+7_1': { x: 52.1, y: 51.3, w: 33.3, h: 35.6 },
  'J_1+7_7': { x: 33.7, y: -3.7, w: 26.7, h: 28.3 },
  'W_1': { x: -0.8, y: 53.9, w: 33.3, h: 35.6 },
  'W_2': { x: 62.4, y: 60.5, w: 37.1, h: 36.8 },
  'W_3': { x: 82.6, y: -1.6, w: 24, h: 24 },
  'W_4': { x: 89.7, y: 10.3, w: 13.2, h: 11.9 },
  'W_4+5_4': { x: 89.7, y: 10.3, w: 13.2, h: 11.9 },
  'W_4+5_5': { x: 72.4, y: -7.9, w: 26, h: 36 },
  'W_5': { x: 82.4, y: -6.1, w: 26, h: 36 },
  'W_6': { x: 82.9, y: -2.1, w: 26.9, h: 27.1 },
  'W_7': { x: 83.2, y: -3.9, w: 27.5, h: 27.7 },
  'Z_7': { x: 60, y: -2.6, w: 23.8, h: 23 },
  'Z_1+7_7': { x: 57.7, y: -3.9, w: 27.5, h: 27.7 },
  'Z_1+7_1': { x: 5.5, y: 54.5, w: 32.5, h: 33.8 },
  'Z_1+3_1': { x: 5.5, y: 54.5, w: 32.5, h: 33.8 },
  'Z_1+3_3': { x: 58.9, y: -4.2, w: 24, h: 24 },
  'Z_1+4_1': { x: 5.5, y: 54.5, w: 32.5, h: 33.8 },
  'Z_1+4_4': { x: 67.1, y: 7.6, w: 10.8, h: 10.3 },
  'Z_1+4+5_1': { x: 5.5, y: 54.5, w: 32.5, h: 33.8 },
  'Z_1+4+5_4': { x: 57.3, y: 11.3, w: 10.8, h: 10.3 },
  'Z_1+4+5_5': { x: 60, y: -7.8, w: 26, h: 36 },
  'Z_4+5_4': { x: 57.3, y: 11.3, w: 10.8, h: 10.3 },
  'Z_4+5_5': { x: 60, y: -7.8, w: 26, h: 36 },
  'Z_6': { x: 61.3, y: -1.3, w: 25.1, h: 25 },
  'Z_2': { x: 1.3, y: 54.7, w: 38.7, h: 43.7 },
  'Z_2+4_2': { x: 1.3, y: 54.7, w: 38.7, h: 43.7 },
  'Z_2+4_4': { x: 66.8, y: 7.4, w: 11.1, h: 11.1 },
  'Z_4': { x: 66.8, y: 7.4, w: 11.1, h: 11.1 },
  'Y_4': { x: 66.8, y: 7.4, w: 11.1, h: 11.1 },
  'Y_1': { x: 18.7, y: 52.4, w: 33.3, h: 36.2 },
  'Y_1+3_1': { x: 18.7, y: 52.4, w: 33.3, h: 36.2 },
  'Y_1+3_3': { x: 61.8, y: -1.8, w: 24, h: 24 },
  'Y_1+5_1': { x: 18.7, y: 52.4, w: 33.3, h: 36.2 },
  'Y_1+5_5': { x: 65, y: -7.6, w: 26, h: 36 },
  'Y_1+4+5_1': { x: 18.7, y: 52.4, w: 33.3, h: 36.2 },
  'Y_1+4+5_5': { x: 65, y: -7.6, w: 26, h: 36 },
  'Y_1+4+5_4': { x: 62.6, y: 11.6, w: 9, h: 9 },
  'Y_4+5_5': { x: 65, y: -7.6, w: 26, h: 36 },
  'Y_4+5_4': { x: 62.6, y: 11.6, w: 9, h: 9 },
  'Y_6': { x: 61.1, y: -3.7, w: 26.7, h: 31.3 },
  'Y_7': { x: 61.1, y: -5, w: 26.9, h: 29.1 },
  'A_1+7_1': { x: 60.5, y: 54, w: 34.3, h: 32.2 },
  'A_1+7_7': { x: 40.5, y: -2.9, w: 21.7, h: 24.3 },
  'A_1+6_1': { x: 60.5, y: 54, w: 34.3, h: 32.2 },
  'A_1+6_6': { x: 38.9, y: -3.2, w: 26.9, h: 27.6 },
  'A_1+5_1': { x: 60.5, y: 54, w: 34.3, h: 32.2 },
  'A_1+5_5': { x: 40.3, y: -5.8, w: 26, h: 36 },
  'A_1+4_1': { x: 60.5, y: 54, w: 34.3, h: 32.2 },
  'A_1+4_4': { x: 47.4, y: 4.5, w: 12.9, h: 12.7 },
  'A_1+3_1': { x: 60.5, y: 54, w: 34.3, h: 32.2 },
  'A_1+3_3': { x: 40.8, y: -2.1, w: 24, h: 24 },
  'B_1+4_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'B_1+4_4': { x: 64.5, y: 5.8, w: 12.2, h: 10.8 },
  'B_1+5_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'B_1+5_5': { x: 58.9, y: -4.5, w: 23.9, h: 34.2 },
  'C_1+3_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'C_1+3_3': { x: 61.8, y: -0.5, w: 24, h: 24 },
  'C_1+5_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'C_1+5_5': { x: 64.2, y: -2.9, w: 26, h: 36 },
  'C_1+7_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'C_1+7_7': { x: 65.3, y: 4, w: 20.9, h: 21.7 },
  'D_1+5_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'D_1+5_5': { x: 62.9, y: -4.2, w: 26, h: 36 },
  'E_1+5_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'E_1+5_5': { x: 65.5, y: -6, w: 26, h: 36 },
  'E_1+3_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'E_1+3_3': { x: 60.5, y: -2.4, w: 24, h: 24 },
  'T_1+4_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_1+4_4': { x: 73.4, y: 7.1, w: 12.4, h: 10.8 },
  'T_1+4+5_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_1+4+5_4': { x: 62.6, y: 10.3, w: 10.8, h: 9.7 },
  'T_1+4+5_5': { x: 68.9, y: -4.4, w: 26, h: 36 },
  'T_1+5_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_1+5_5': { x: 68.9, y: -4.4, w: 26, h: 36 },
  'T_1+3+5_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_1+3+5_5': { x: 4.4, y: -4.9, w: 26, h: 36 },
  'T_1+3+5_3': { x: 65.5, y: -2.9, w: 24, h: 24 },
  'T_1+3_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_1+3_3': { x: 65.5, y: -2.9, w: 24, h: 24 },
  'T_1+6_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_1+6_6': { x: 64.5, y: -1.1, w: 24.3, h: 23.1 },
  'T_1+7_1': { x: 31.5, y: 55.5, w: 30.9, h: 31.2 },
  'T_1+7_7': { x: 65.3, y: -2.1, w: 23.3, h: 24.3 },
  'C_1+6+7_1': { x: 5.2, y: 54.8, w: 34.3, h: 32.2 },
  'C_1+6+7_7': { x: 65.3, y: 4, w: 20.9, h: 21.7 },
  'C_1+6+7_6': { x: 62.6, y: 56.6, w: 24.6, h: 24.4 },
  'L_1+2_1': { x: 4.7, y: 53.7, w: 31.4, h: 35.6 },
  'L_1+2_2': { x: 55.5, y: 56.6, w: 45, h: 41.6 },
  'M_1+2+3_1': { x: 69.5, y: 50, w: 35.4, h: 41.4 },
  'M_1+2+3_2': { x: -11.8, y: 59.5, w: 42.9, h: 35 },
  'M_1+2+3_3': { x: 73.4, y: -4.2, w: 25.6, h: 26.4 },
};
// Posizioni di fallback distribuite — usate quando non c'è configurazione preimpostata.
// L'indice corrisponde all'ordine della decorazione nell'array attivo (0 = prima, 1 = seconda, ecc.)
// così due decorazioni non configurate non finiscono mai nello stesso punto.
const DEFAULT_DECORATION_POSITIONS = [
  { x: 58, y:  2, w: 24, h: 28 },  // 1ª — alto destra
  { x:  8, y:  2, w: 24, h: 28 },  // 2ª — alto sinistra
  { x: 62, y: 56, w: 22, h: 26 },  // 3ª — basso destra
  { x:  6, y: 56, w: 22, h: 26 },  // 4ª — basso sinistra
  { x: 35, y: -4, w: 26, h: 30 },  // 5ª — alto centro
];

/* ═══════════════════════════════════════════════════════
   AUTO-PLACEMENT — fallback intelligente basato sui pixel della lettera
   Regola: almeno 85% dell'area della decorazione deve coprire massa della lettera.
   Evita sovrapposizioni tra decorazioni già piazzate nello stesso render.
═══════════════════════════════════════════════════════ */

const _letterMaskCache = {};   // { 'A': Uint8ClampedArray, ... }
let   _autoPlacedRects  = [];  // reset a ogni render(), usato da getDecorationPos

/** Disegna la lettera su canvas offscreen e restituisce i dati RGBA dei pixel. */
function buildLetterMask(letter) {
  const L = letter.toUpperCase();
  if (_letterMaskCache[L]) return _letterMaskCache[L];

  const ofc  = document.createElement('canvas');
  ofc.width  = CW;
  ofc.height = CH;
  const octx = ofc.getContext('2d');

  octx.font         = `${LETTER_FONT_SIZE}px "Westerniya Serif"`;
  octx.textAlign    = 'center';
  octx.textBaseline = 'alphabetic';
  octx.fillStyle    = '#000000';
  octx.fillText(L, LETTER_X, LETTER_Y);

  _letterMaskCache[L] = octx.getImageData(0, 0, CW, CH).data;
  return _letterMaskCache[L];
}

/**
 * Quanti pixel della lettera cadono nel rettangolo (percentuali 0-100)?
 * Restituisce un valore 0.0–1.0 (frazione sul totale del rettangolo).
 */
function getLetterCoverage(mask, xPct, yPct, wPct, hPct) {
  const x0 = Math.round(xPct / 100 * CW);
  const y0 = Math.round(yPct / 100 * CH);
  const pw  = Math.round(wPct / 100 * CW);
  const ph  = Math.round(hPct / 100 * CH);
  if (pw <= 0 || ph <= 0) return 0;

  let letter = 0;
  const total = pw * ph;

  for (let r = 0; r < ph; r++) {
    const py = y0 + r;
    for (let c = 0; c < pw; c++) {
      const px = x0 + c;
      if (px >= 0 && px < CW && py >= 0 && py < CH) {
        if (mask[(py * CW + px) * 4 + 3] > 30) letter++;
      }
      // pixel fuori canvas → non lettera (conta nel denominatore)
    }
  }
  return letter / total;
}

/** Verifica se due rettangoli (in % 0-100) si sovrappongono. */
function rectsOverlap(a, b) {
  return a.x < b.x + b.w && a.x + a.w > b.x &&
         a.y < b.y + b.h && a.y + a.h > b.y;
}

/** Cerca nelle posizioni già salvate la dimensione tipica di una decorazione. */
function getDefaultDecSize(decId) {
  for (const key of Object.keys(DECORATION_POSITIONS)) {
    const parts = key.split('_');
    // chiave singola es. 'A_1' — solo lettera + id
    if (parts.length === 2 && parseInt(parts[1]) === decId) {
      const p = DECORATION_POSITIONS[key];
      return { w: p.w, h: p.h };
    }
  }
  return { w: 22, h: 22 };
}

/** Distanza minima dal centro del candidato ai centri dei rettangoli già piazzati. */
function getSpreadScore(rect, placed) {
  if (!placed.length) return 999;
  const cx = rect.x + rect.w / 2;
  const cy = rect.y + rect.h / 2;
  return Math.min(...placed.map(p => {
    const dx = cx - (p.x + p.w / 2);
    const dy = cy - (p.y + p.h / 2);
    return Math.sqrt(dx * dx + dy * dy);
  }));
}

/**
 * Piazza automaticamente una decorazione:
 * 1. Cerca posizioni con ≥ 85% di copertura lettera, senza sovrapposizioni.
 * 2. Se non trova, rilassa a ≥ 70% ignorando le sovrapposizioni.
 * 3. Tra i candidati validi sceglie quello più lontano dagli altri (spread).
 */
function autoPlaceDecoration(letter, decId, alreadyPlaced) {
  const mask = buildLetterMask(letter);
  const { w, h } = getDefaultDecSize(decId);
  const STEPS = 28;

  function scan(minCov, allowOverlap) {
    const candidates = [];
    for (let xi = 0; xi <= STEPS; xi++) {
      for (let yi = 0; yi <= STEPS; yi++) {
        const x = -8 + (xi / STEPS) * (100 - w + 6);
        const y = -8 + (yi / STEPS) * (100 - h + 6);
        if (getLetterCoverage(mask, x, y, w, h) < minCov) continue;
        const rect = { x, y, w, h };
        if (!allowOverlap && alreadyPlaced.some(p => rectsOverlap(rect, p))) continue;
        candidates.push(rect);
      }
    }
    return candidates;
  }

  let candidates = scan(0.85, false);
  if (!candidates.length) candidates = scan(0.70, false);
  if (!candidates.length) candidates = scan(0.70, true);
  if (!candidates.length) return DEFAULT_DECORATION_POSITIONS[alreadyPlaced.length % DEFAULT_DECORATION_POSITIONS.length];

  // Sceglie il candidato con spread massimo dagli altri
  candidates.sort((a, b) => getSpreadScore(b, alreadyPlaced) - getSpreadScore(a, alreadyPlaced));
  return candidates[0];
}

const BG_URL = 'https://cdn.shopify.com/s/files/1/0959/2455/2019/files/sfondo_lettera_personalizzata_con_nome_1.png?v=1775575498';

/* ═══════════════════════════════════════════════════════
   STATE
═══════════════════════════════════════════════════════ */

const state = {
  letter:      'A',
  name:        'Aurora',
  letterColor: COLORS[0],
  nameColor:   COLORS[8],
  decorations: [], // Array di id decorazioni attive (duplicati ammessi)
};

/* ═══════════════════════════════════════════════════════
   PERSISTENZA — salva/ripristina la configurazione (localStorage)
   Così l'utente che esce e rientra ritrova la sua personalizzazione.
═══════════════════════════════════════════════════════ */
const PL_STORAGE_KEY = 'pl_config_v1';

function saveState() {
  try {
    localStorage.setItem(PL_STORAGE_KEY, JSON.stringify({
      letter:         state.letter,
      name:           state.name,
      letterColorHex: state.letterColor.hex,
      nameColorHex:   state.nameColor.hex,
      decorations:    state.decorations,
    }));
  } catch (e) { /* localStorage non disponibile: ignora */ }
}

function loadState() {
  try {
    const raw = localStorage.getItem(PL_STORAGE_KEY);
    if (!raw) return;
    const s = JSON.parse(raw);
    if (typeof s.letter === 'string') state.letter = s.letter;
    if (typeof s.name   === 'string') state.name   = s.name;
    const lc = COLORS.find(c => c.hex === s.letterColorHex);
    if (lc) state.letterColor = lc;
    const nc = COLORS.find(c => c.hex === s.nameColorHex);
    if (nc) state.nameColor = nc;
    if (Array.isArray(s.decorations)) {
      state.decorations = s.decorations.filter(x => typeof x === 'number');
    }
  } catch (e) { /* dati corrotti: ignora */ }
}

// Ripristina subito lo stato salvato (prima che la UI venga costruita)
loadState();

/* ═══════════════════════════════════════════════════════
   CANVAS + ASSETS
═══════════════════════════════════════════════════════ */

const canvas = document.getElementById('previewCanvas');
const ctx    = canvas.getContext('2d');
const CW = 760, CH = 760;  // canvas internal resolution

// Canvas di misura separato (non toccato da drawImage → mai tainted)
const _mc  = document.createElement('canvas');
const _mct = _mc.getContext('2d');

// Canvas offscreen riutilizzabile per la texture (evita allocazioni ripetute)
const _texCanvas = document.createElement('canvas');
_texCanvas.width  = CW;
_texCanvas.height = CH;
const _tc = _texCanvas.getContext('2d');

/*
  Noise texture pre-generata una volta sola.
  Grana a blocchi 2×2px con valori deterministici → aspetto ruvido/matto.
  Applicata con blend mode 'overlay' a bassa opacità: visibile sulla superficie
  piatta della lettera, quasi invisibile sullo sfondo fotografico.
*/
const _noiseCanvas = (() => {
  const nc   = document.createElement('canvas');
  nc.width   = CW; nc.height = CH;
  const nctx = nc.getContext('2d');
  const id   = nctx.createImageData(CW, CH);
  const d    = id.data;
  const G    = 2; // dimensione blocco in px (grana fine)
  for (let y = 0; y < CH; y++) {
    for (let x = 0; x < CW; x++) {
      const bx = x >> 1, by = y >> 1; // equivale a Math.floor(x/G) con G=2
      // Hash deterministica per blocco → grain coerente tra frame
      const v  = ((bx * 1301 + by * 7919 + (bx ^ by) * 409) & 0xFF);
      const i  = (y * CW + x) * 4;
      d[i] = d[i+1] = d[i+2] = v;
      d[i+3] = 255;
    }
  }
  nctx.putImageData(id, 0, 0);
  return nc;
})();

const bgImage = new Image();
bgImage.crossOrigin = 'anonymous';
bgImage.src = BG_URL;
bgImage.onload  = () => render();
bgImage.onerror = () => render(); // fallback: render senza sfondo

/* ═══════════════════════════════════════════════════════
   UTILS
═══════════════════════════════════════════════════════ */

function hexToRgb(hex) {
  hex = hex.replace('#', '');
  return { r: parseInt(hex.slice(0,2),16), g: parseInt(hex.slice(2,4),16), b: parseInt(hex.slice(4,6),16) };
}

function darkenColor(hex, amount = 0.40) {
  const { r, g, b } = hexToRgb(hex);
  const d = v => Math.max(0, Math.floor(v * (1 - amount)));
  return `rgb(${d(r)},${d(g)},${d(b)})`;
}

function isWhite(hex) {
  return hex.replace('#','').toUpperCase() === 'FFFFFF';
}

/* Ricerca binaria per trovare il font-size che porta il testo
   esattamente a targetPx di larghezza (advance width). */
function fitFontSize(text, targetPx, fontFamily = 'Berow', maxPx = 400) {
  if (!text) return 0;
  let lo = 8, hi = maxPx;
  for (let i = 0; i < 22; i++) {
    const mid = (lo + hi) / 2;
    _mct.font = `${mid}px "${fontFamily}"`;
    (_mct.measureText(text).width > targetPx) ? (hi = mid) : (lo = mid);
  }
  return Math.floor(lo);
}

/* Offset orizzontale in px per compensare il bearing asimmetrico
   dei font script (differenza tra centro advance e centro inchiostro). */
function inkCenterOffset(text, fontSize, fontFamily = 'Berow') {
  if (!text) return 0;
  _mct.font = `${fontSize}px "${fontFamily}"`;
  const m = _mct.measureText(text);
  if (m.actualBoundingBoxLeft === undefined) return 0;
  return (m.actualBoundingBoxRight - m.actualBoundingBoxLeft) / 2 - m.width / 2;
}

/* ═══════════════════════════════════════════════════════
   BACKGROUND (cover crop)
═══════════════════════════════════════════════════════ */

function drawBackground() {
  if (!bgImage.complete || bgImage.naturalWidth === 0) {
    // Gradiente caldo come fallback
    const grad = ctx.createLinearGradient(0, 0, 0, CH);
    grad.addColorStop(0, '#f5ede4');
    grad.addColorStop(1, '#e8d8c8');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, CW, CH);
    return;
  }
  const ir = bgImage.naturalWidth / bgImage.naturalHeight;
  const cr = CW / CH;
  let sx = 0, sy = 0, sw = bgImage.naturalWidth, sh = bgImage.naturalHeight;
  if (ir > cr) {
    sw = sh * cr;
    sx = (bgImage.naturalWidth - sw) / 2;
  } else {
    sh = sw / cr;
    sy = (bgImage.naturalHeight - sh) / 2;
  }
  ctx.drawImage(bgImage, sx, sy, sw, sh, 0, 0, CW, CH);

  // Velo leggero per non sovrastare la lettera
  ctx.fillStyle = 'rgba(255,255,255,0.18)';
  ctx.fillRect(0, 0, CW, CH);
}

/* ═══════════════════════════════════════════════════════
   LETTER — Westerniya Serif + estrusione 3D
═══════════════════════════════════════════════════════ */

/*
  Estrusione isometrica: disegna N copie della lettera spostate
  progressivamente verso destra-basso (asse di profondità),
  simulando lo spessore fisico ~2cm su 20cm di altezza.

  Direzione visiva: angolo ~33° (destra + leggermente in basso)
  Spessore totale: DEPTH_LAYERS × DEPTH_STEP  ≈ 35px su 760 → ~4.6%
  che su una lettera di 650px = ~30px ≈ ~4.6% = proporzione 2/20 = 10%
  (leggermente esagerato per leggibilità a schermo — il materiale è opaco)
*/
const LETTER_FONT_SIZE = 864;
const LETTER_X = CW / 2;
// textBaseline 'alphabetic': LETTER_Y è la baseline delle maiuscole.
// Al 85% del canvas il fondo della lettera è a ~15% dal bordo inferiore.
const LETTER_Y = CH * 0.85;

const DEPTH_LAYERS = 12;
// Vista frontale: profondità quasi verticale — si vede solo il bordo inferiore
// del materiale (lettera leggermente inclinata dalla prospettiva dall'alto)
const DEPTH_DX     = 0.5;
const DEPTH_DY     = 2.6;

// Nome: spessore ridotto (il pezzo in acrilico/legno è più sottile)
const NAME_DEPTH_LAYERS = 5;
const NAME_DEPTH_DX     = 0.4;
const NAME_DEPTH_DY     = 1.6;

function drawLetter(letter, color) {
  const depthColor = darkenColor(color, 0.18);

  ctx.font = `${LETTER_FONT_SIZE}px "Westerniya Serif"`;
  ctx.textAlign    = 'center';
  ctx.textBaseline = 'alphabetic';

  // Centro visivo della lettera (baseline - metà altezza maiuscole ≈ 65% font size)
  const capHeight = LETTER_FONT_SIZE * 0.65;
  const centerY   = LETTER_Y - capHeight * 0.5;

  // Convergenza prospettica: ogni layer più lontano è più stretto.
  // Simula il cono visivo di un oggetto fisico visto frontalmente.
  const MAX_CONVERGE = 0.06; // 6% di restringimento al layer più lontano

  function depthLayer(i, dy) {
    // scaleX decresce all'aumentare di i (layer più lontano = più stretto)
    const scaleX = 1 - (i / DEPTH_LAYERS) * MAX_CONVERGE;
    ctx.save();
    ctx.translate(LETTER_X, 0);   // ancora il punto di scala al centro X
    ctx.scale(scaleX, 1);
    ctx.translate(-LETTER_X, 0);
    ctx.fillStyle = depthColor;
    ctx.fillText(letter, LETTER_X, LETTER_Y + dy);
    ctx.restore();
  }

  // METÀ SUPERIORE — profondità verso il basso (cono rovesciato)
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, 0, CW, centerY);
  ctx.clip();
  for (let i = DEPTH_LAYERS; i >= 1; i--) depthLayer(i, +i * DEPTH_DY);
  ctx.restore();

  // METÀ INFERIORE — profondità verso l'alto (cono)
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, centerY, CW, CH - centerY);
  ctx.clip();
  for (let i = DEPTH_LAYERS; i >= 1; i--) depthLayer(i, -i * DEPTH_DY);
  ctx.restore();

  // FACCIA FRONTALE — copre la giunzione e fornisce il colore finale
  ctx.fillStyle = color;
  ctx.fillText(letter, LETTER_X, LETTER_Y);
}

/* ═══════════════════════════════════════════════════════
   NAME — Berow + estrusione sottile
═══════════════════════════════════════════════════════ */

// Renderizza una singola riga del nome con effetto 3D depth
function drawNameLine(text, fontSize, textColor, nameY) {
  const offsetX = inkCenterOffset(text, fontSize, 'Berow');
  const nameX   = CW / 2 - offsetX;

  const nameDepthColor = isWhite(state.letterColor.hex)
    ? darkenColor(textColor, 0.32)
    : 'rgba(140,140,140,0.70)';

  ctx.font         = `${fontSize}px "Berow"`;
  ctx.textAlign    = 'center';
  ctx.textBaseline = 'middle';

  const NAME_CONVERGE = 0.05;

  function depthLayer(i, dy) {
    const scaleX = 1 - (i / NAME_DEPTH_LAYERS) * NAME_CONVERGE;
    ctx.save();
    ctx.translate(nameX, 0);
    ctx.scale(scaleX, 1);
    ctx.translate(-nameX, 0);
    ctx.fillStyle = nameDepthColor;
    ctx.fillText(text, nameX, nameY + dy);
    ctx.restore();
  }

  // METÀ SUPERIORE — profondità verso il basso
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, 0, CW, nameY);
  ctx.clip();
  for (let i = NAME_DEPTH_LAYERS; i >= 1; i--) depthLayer(i, +i * NAME_DEPTH_DY);
  ctx.restore();

  // METÀ INFERIORE — profondità verso l'alto
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, nameY, CW, CH - nameY);
  ctx.clip();
  for (let i = NAME_DEPTH_LAYERS; i >= 1; i--) depthLayer(i, -i * NAME_DEPTH_DY);
  ctx.restore();

  // Faccia frontale
  ctx.fillStyle = textColor;
  ctx.fillText(text, nameX, nameY);
}

function drawName(name, textColor) {
  if (!name) return;

  const parts   = name.trim().split(/\s+/);
  // -60px canvas ≈ -30px a schermo (canvas 760 visualizzato a ~380)
  const centerY = LETTER_Y - LETTER_FONT_SIZE * 0.30 - 60;

  if (parts.length >= 2) {
    // Nome composto: due righe con lo stesso font size
    // (calcolato sul testo più lungo per mantenere proporzioni)
    const fs1      = fitFontSize(parts[0],                  CW * 0.67, 'Berow');
    const fs2      = fitFontSize(parts.slice(1).join(' '),  CW * 0.67, 'Berow');
    const fontSize = Math.min(fs1, fs2);
    // spacing = distanza tra i centri delle due righe.
    // capHeight ≈ 62% del fontSize → gap visivo ≈ 40px fissi tra le righe
    const spacing  = fontSize * 0.62 + 20;

    drawNameLine(parts[0],                 fontSize, textColor, centerY - spacing / 2);
    drawNameLine(parts.slice(1).join(' '), fontSize, textColor, centerY + spacing / 2);
  } else {
    // Nome singolo — comportamento invariato
    const fontSize = fitFontSize(name, CW * 0.67, 'Berow');
    drawNameLine(name, fontSize, textColor, centerY);
  }
}

/* ═══════════════════════════════════════════════════════
   GROUND SHADOW — ombra ellittica sotto la base della lettera
═══════════════════════════════════════════════════════ */

function drawGroundShadow() {
  // Stima larghezza lettera per dimensionare l'ellisse
  _mct.font = `${LETTER_FONT_SIZE}px "Westerniya Serif"`;
  const lw = _mct.measureText((state.letter || 'A').toUpperCase()).width;

  const cx = LETTER_X;
  const cy = LETTER_Y + 4; // tocca la base della lettera

  ctx.save();
  ctx.shadowColor   = 'rgba(0,0,0,0.45)';
  ctx.shadowBlur    = 22;
  ctx.shadowOffsetY = 4;
  ctx.fillStyle     = 'rgba(0,0,0,0.28)';
  ctx.beginPath();
  ctx.ellipse(cx, cy, lw * 0.44, 14, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}

/* ═══════════════════════════════════════════════════════
   DECORATION
═══════════════════════════════════════════════════════ */

function getDecorationPos(letter, decId, globalIndex = 0) {
  const L = letter.toUpperCase();
  const uniqueIds = [...new Set(state.decorations)].sort((a, b) => a - b);
  const instanceIdx = state.decorations.slice(0, globalIndex).filter(id => id === decId).length;

  let pos = null;

  // ── PRIORITÀ 1: chiave combo+istanza (configurata sapendo di tutte le decorazioni)
  if (uniqueIds.length > 1) {
    const combo = uniqueIds.join('+');
    if (instanceIdx > 0) {
      const iKey = `${L}_${combo}_${decId}_i${instanceIdx}`;
      if (DECORATION_POSITIONS[iKey]) pos = DECORATION_POSITIONS[iKey];
    }
    if (!pos) {
      const combinedKey = `${L}_${combo}_${decId}`;
      if (DECORATION_POSITIONS[combinedKey]) pos = DECORATION_POSITIONS[combinedKey];
    }
  }

  // ── PRIORITÀ 2: chiave singola con indice istanza
  if (!pos && instanceIdx > 0) {
    const iKey = `${L}_${decId}_i${instanceIdx}`;
    if (DECORATION_POSITIONS[iKey]) pos = DECORATION_POSITIONS[iKey];
  }

  // Se abbiamo una posizione da chiave combo o istanza specifica → usala
  // (è stata configurata consapevolmente per questa combinazione esatta)
  if (pos) {
    _autoPlacedRects.push({ x: pos.x, y: pos.y, w: pos.w, h: pos.h });
    return pos;
  }

  // ── PRIORITÀ 3: chiave singola base (es. C_2)
  // Usala solo se NON collide con le decorazioni già piazzate in questo render.
  // Se collide → l'auto-placement trova una posizione libera.
  if (DECORATION_POSITIONS[`${L}_${decId}`]) {
    const candidate = DECORATION_POSITIONS[`${L}_${decId}`];
    const rect = { x: candidate.x, y: candidate.y, w: candidate.w, h: candidate.h };
    if (!_autoPlacedRects.some(p => rectsOverlap(rect, p))) {
      _autoPlacedRects.push(rect);
      return candidate;
    }
  }

  // ── PRIORITÀ 4: auto-placement intelligente (pixel-aware + collision avoidance)
  pos = autoPlaceDecoration(letter, decId, _autoPlacedRects.slice());
  _autoPlacedRects.push({ x: pos.x, y: pos.y, w: pos.w, h: pos.h });
  return pos;
}

async function tintImage(imgSrc, targetHex) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const oc  = document.createElement('canvas');
      oc.width  = img.naturalWidth;
      oc.height = img.naturalHeight;
      const octx = oc.getContext('2d');
      octx.drawImage(img, 0, 0);
      const id   = octx.getImageData(0, 0, oc.width, oc.height);
      const data = id.data;
      const { r: tr, g: tg, b: tb } = hexToRgb(targetHex);
      for (let i = 0; i < data.length; i += 4) {
        if (data[i+3] === 0) continue;
        const lum = (data[i] + data[i+1] + data[i+2]) / (3 * 255);
        data[i]   = Math.round(tr * lum);
        data[i+1] = Math.round(tg * lum);
        data[i+2] = Math.round(tb * lum);
      }
      octx.putImageData(id, 0, 0);
      resolve(oc);
    };
    img.onerror = reject;
    img.src = imgSrc;
  });
}

/* ═══════════════════════════════════════════════════════
   SVG-AS-IMAGE — cache e rendering per SVG complessi (Orsetto)
═══════════════════════════════════════════════════════ */
const _svgImgCache = new Map();

function getSvgImage(dec, colorHex) {
  const key = `${dec.id}_${colorHex}`;
  if (_svgImgCache.has(key)) return Promise.resolve(_svgImgCache.get(key));

  const svgStr = dec.svgTemplate.replaceAll('{{LETTER_COLOR}}', colorHex);
  const blob   = new Blob([svgStr], { type: 'image/svg+xml' });
  const url    = URL.createObjectURL(blob);

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      _svgImgCache.set(key, img);
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
}

async function drawSvgImgDecoration(dec, dx, dy, dw, dh) {
  try {
    const img = await getSvgImage(dec, state.letterColor.hex);
    const [,, vw, vh] = dec.svgViewBox;
    const scale   = Math.min(dw / vw, dh / vh);
    const offsetX = (dw - vw * scale) / 2;
    const offsetY = (dh - vh * scale) / 2;
    ctx.save();
    ctx.shadowColor   = 'rgba(0,0,0,0.22)';
    ctx.shadowBlur    = 8;
    ctx.shadowOffsetX = 2;
    ctx.shadowOffsetY = 3;
    ctx.drawImage(img, dx + offsetX, dy + offsetY, vw * scale, vh * scale);
    ctx.restore();
  } catch (e) {
    console.warn('SVG-img decorazione non caricata:', e);
  }
}

async function drawDecoration(dec, globalIndex = 0) {
  if (!dec) return;

  const pos = getDecorationPos(state.letter, dec.id, globalIndex);
  const dx = (pos.x / 100) * CW;
  const dy = (pos.y / 100) * CH;
  const dw = (pos.w / 100) * CW;
  const dh = (pos.h / 100) * CH;

  if (dec.type === 'svg-img') {
    await drawSvgImgDecoration(dec, dx, dy, dw, dh);
    return;
  }

  if (dec.type === 'svg') {
    drawSvgDecoration(dec, dx, dy, dw, dh);
    return;
  }

  // PNG
  if (!dec.src) return;
  try {
    if (dec.colorize) {
      const tinted = await tintImage(dec.src, state.letterColor.hex);
      ctx.drawImage(tinted, dx, dy, dw, dh);
    } else {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = dec.src; });
      ctx.drawImage(img, dx, dy, dw, dh);
    }
  } catch (e) {
    console.warn('Decorazione non caricata:', e);
  }
}

function drawSvgDecoration(dec, dx, dy, dw, dh) {
  const [, , vw, vh] = dec.svgViewBox;

  // Scala uniforme: fit proporzionale dentro il box (no distorsione)
  const scale = Math.min(dw / vw, dh / vh);
  // Centra la decorazione nel box
  const offsetX = (dw - vw * scale) / 2;
  const offsetY = (dh - vh * scale) / 2;

  ctx.save();
  ctx.translate(dx + offsetX, dy + offsetY);
  ctx.scale(scale, scale);

  // Ombra — usa shadow personalizzata se definita sulla decorazione
  const sh = dec.shadow || { color: 'rgba(0,0,0,0.22)', blur: 8, offsetX: 2, offsetY: 3 };
  ctx.shadowColor   = sh.color;
  ctx.shadowBlur    = sh.blur;
  ctx.shadowOffsetX = sh.offsetX;
  ctx.shadowOffsetY = sh.offsetY;

  // Formato multi-path (nuvoletta, mongolfiera…)
  if (dec.svgPaths) {
    dec.svgPaths.forEach(p => {
      ctx.save();
      if (p.transform) ctx.transform(...p.transform);
      const isLetterColor = p.fill === 'LETTER_COLOR';
      const fillColor = isLetterColor
        ? state.letterColor.hex
        : (p.fill || dec.color || '#FFFFFF');
      // Se è il colore lettera, applica un'ombra dedicata per renderlo visibile
      // anche quando sovrapposto alla lettera dello stesso colore
      if (isLetterColor) {
        ctx.shadowColor   = 'rgba(0,0,0,0.45)';
        ctx.shadowBlur    = 10;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 3;
      }
      ctx.fillStyle = fillColor;
      ctx.fill(new Path2D(p.d), 'evenodd');
      ctx.restore();
      ctx.shadowColor = 'transparent'; // ombra solo sul primo layer
    });
  } else {
    // Formato singolo path (farfalla)
    ctx.save();
    if (dec.svgTransform) ctx.transform(...dec.svgTransform);
    ctx.fillStyle = dec.color || '#FFFFFF';
    ctx.fill(new Path2D(dec.svgPath), 'evenodd');
    ctx.restore();
  }

  ctx.restore();
}

/* ═══════════════════════════════════════════════════════
   MAIN RENDER
═══════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════
   PRICE SUMMARY
═══════════════════════════════════════════════════════ */
const DECORATION_PRICES = { 1: 4, 2: 2, 3: 1, 4: 1, 5: 2, 6: 1, 7: 1 };
const BASE_PRICE        = 14.90;
const FREE_SHIP_THRESHOLD = 19.90;

function fmt(n) {
  return '€' + n.toFixed(2).replace('.', ',');
}

function updatePrice() {
  let total = BASE_PRICE;
  const rowsEl = document.getElementById('priceRowDecs');
  rowsEl.innerHTML = '';

  // Raggruppa decorazioni per ID per mostrare quantità
  const decCounts = {};
  state.decorations.forEach(id => { decCounts[id] = (decCounts[id] || 0) + 1; });
  for (const [decIdStr, count] of Object.entries(decCounts)) {
    const decId = Number(decIdStr);
    const dec   = DECORATIONS.find(d => d.id === decId);
    const price = (DECORATION_PRICES[decId] || 0) * count;
    if (!dec) continue;
    total += price;
    const row = document.createElement('div');
    row.className = 'price-row';
    const label = count > 1 ? `${dec.icon} ${dec.name} ×${count}` : `${dec.icon} ${dec.name}`;
    row.innerHTML = `
      <span class="price-row-label">${label}</span>
      <span class="price-row-amount plus">+${fmt(price)}</span>
    `;
    rowsEl.appendChild(row);
  }

  document.getElementById('priceTotalAmount').textContent = fmt(total);

  const banner = document.getElementById('shippingBanner');
  if (total >= FREE_SHIP_THRESHOLD) {
    banner.className = 'shipping-banner free';
    banner.textContent = '✅ Hai la spedizione Gratis!';
  } else {
    banner.className = 'shipping-banner pending';
    banner.textContent = '📦 Spedizione gratuita per ordini superiori a €19,90';
  }
}

async function render() {
  _autoPlacedRects = []; // reset collision tracking per ogni render
  saveState(); // persiste la configurazione a ogni modifica
  updatePrice();
  updatePositionNotice();
  updateGallery();
  ctx.clearRect(0, 0, CW, CH);

  const { letter, name, letterColor, nameColor, decorations } = state;
  const validLetter = (letter || '').toUpperCase().match(/^[A-Z]$/);

  // 1. Sfondo
  drawBackground();

  // 2. Ombra a terra + Lettera
  if (validLetter) {
    drawGroundShadow();
    drawLetter(validLetter[0], letterColor.hex);
  }

  // 3. Nome
  if (name) {
    const textColor = isWhite(letterColor.hex) ? nameColor.hex : '#FFFFFF';
    drawName(name, textColor);
  }

  // 4. Texture ruvida — solo su lettera e nome, prima delle decorazioni
  //    così le decorazioni sovrapposte non ricevono la texture
  if (validLetter) {
    applyLetterTexture(validLetter[0], name);
  }

  // 5. Decorazioni (tutte quelle selezionate) — sopra la texture
  for (let i = 0; i < decorations.length; i++) {
    const dec = DECORATIONS.find(d => d.id === decorations[i]);
    if (dec) await drawDecoration(dec, i);
  }
}

/*
  Applica la noise texture ritagliata alla sagoma di lettera + nome.
  Tecnica:
  1. Disegna la sagoma (maschera) su _texCanvas
  2. Sovrappone il noise con source-in → rumore ritagliato alla forma
  3. Composite sul canvas principale con overlay → texture solo sulla lettera
*/
function applyLetterTexture(letter, name) {
  _tc.clearRect(0, 0, CW, CH);

  // Maschera lettera
  _tc.font         = `${LETTER_FONT_SIZE}px "Westerniya Serif"`;
  _tc.textAlign    = 'center';
  _tc.textBaseline = 'alphabetic';
  _tc.fillStyle    = '#000';
  _tc.fillText(letter.toUpperCase(), LETTER_X, LETTER_Y);

  // Maschera nome (supporta nomi composti su due righe)
  if (name) {
    const parts   = name.trim().split(/\s+/);
    const centerY = LETTER_Y - LETTER_FONT_SIZE * 0.30;
    _tc.textAlign    = 'center';
    _tc.textBaseline = 'middle';
    if (parts.length >= 2) {
      const fs1 = fitFontSize(parts[0],                 CW * 0.67, 'Berow');
      const fs2 = fitFontSize(parts.slice(1).join(' '), CW * 0.67, 'Berow');
      const fs  = Math.min(fs1, fs2);
      const spacing = fs * 0.62 + 20;
      [parts[0], parts.slice(1).join(' ')].forEach((part, i) => {
        const ny = centerY + (i === 0 ? -spacing / 2 : spacing / 2);
        const ox = inkCenterOffset(part, fs, 'Berow');
        _tc.font = `${fs}px "Berow"`;
        _tc.fillText(part, CW / 2 - ox, ny);
      });
    } else {
      const fs = fitFontSize(name, CW * 0.67, 'Berow');
      const ox = inkCenterOffset(name, fs, 'Berow');
      _tc.font = `${fs}px "Berow"`;
      _tc.fillText(name, CW / 2 - ox, centerY);
    }
  }

  // Noise ritagliato alla sagoma
  _tc.globalCompositeOperation = 'source-in';
  _tc.drawImage(_noiseCanvas, 0, 0);
  _tc.globalCompositeOperation = 'source-over';

  // Applica al canvas principale — solo dove c'è lettera/nome
  ctx.save();
  ctx.globalCompositeOperation = 'overlay';
  ctx.globalAlpha = 0.14;
  ctx.drawImage(_texCanvas, 0, 0);
  ctx.restore();
}

/* ═══════════════════════════════════════════════════════
   FONT LOADING — aspetta che Berow e Westerniya siano pronti
   prima del primo render per evitare fallback glyph
═══════════════════════════════════════════════════════ */

async function initFonts() {
  try {
    await Promise.all([
      document.fonts.load('100px "Berow"'),
      document.fonts.load('100px "Westerniya Serif"'),
    ]);
  } catch(e) { /* continua comunque */ }
  document.getElementById('previewLoading').classList.add('hidden');
  render();
}

/* ═══════════════════════════════════════════════════════
   BUILD UI
═══════════════════════════════════════════════════════ */

function buildColorSwatches(containerId, getSelected, onPick) {
  const container = document.getElementById(containerId);
  COLORS.forEach(color => {
    const sw = document.createElement('div');
    sw.className = 'pl-color-swatch' + (getSelected().hex === color.hex ? ' active' : '');
    sw.style.background = color.hex;
    sw.dataset.hex = color.hex;
    sw.title = color.name;
    sw.addEventListener('click', () => {
      container.querySelectorAll('.pl-color-swatch').forEach(s => s.classList.remove('active'));
      sw.classList.add('active');
      onPick(color);
    });
    container.appendChild(sw);
  });
}

function buildDecorations() {
  const grid = document.getElementById('decorationsGrid');

  const noneBtn = document.createElement('button');
  noneBtn.type = 'button';
  noneBtn.className = 'dec-btn active';
  noneBtn.dataset.decId = 'none';
  noneBtn.innerHTML = `<span class="dec-btn-icon">✕</span><span>Nessuna</span>`;
  noneBtn.addEventListener('click', () => selectDecoration(null));
  grid.appendChild(noneBtn);

  DECORATIONS.forEach(dec => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dec-btn';
    btn.dataset.decId = dec.id;
    const decPrice = DECORATION_PRICES[dec.id];
    const iconHtml = buildDecIconSVG(dec);
    btn.innerHTML = `
      <span class="dec-btn-icon svg-icon">${iconHtml}</span>
      <span>${dec.name}</span>
      ${decPrice ? `<span class="dec-colorize-badge">+€${decPrice}</span>` : ''}
      <span class="dec-count-badge" style="display:none"></span>
      <span class="dec-remove-btn" style="display:none" title="Rimuovi">✕</span>
    `;
    // Click sul bottone principale → aggiunge un'istanza
    btn.addEventListener('click', () => selectDecoration(dec));
    // Click sul tasto X → rimuove TUTTE le istanze di questa decorazione
    const removeBtn = btn.querySelector('.dec-remove-btn');
    removeBtn.addEventListener('click', e => {
      e.stopPropagation();
      removeDecoration(dec.id);
    });
    grid.appendChild(btn);
  });
}

function updateDecButtons() {
  document.querySelectorAll('.dec-btn').forEach(btn => {
    if (btn.dataset.decId === 'none') {
      btn.classList.toggle('active', state.decorations.length === 0);
    } else {
      const id    = Number(btn.dataset.decId);
      const count = state.decorations.filter(d => d === id).length;
      btn.classList.toggle('active', count > 0);

      const badge     = btn.querySelector('.dec-count-badge');
      const removeBtn = btn.querySelector('.dec-remove-btn');
      if (badge) {
        if (count > 1) {
          badge.textContent = `×${count}`;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      }
      if (removeBtn) {
        removeBtn.style.display = count > 0 ? '' : 'none';
      }
    }
  });
}

function buildDecIconSVG(dec) {
  const DEFAULT_COLOR = '#EDD0D1'; // Rosa — colore neutro di default per le icone
  const ICON_WHITE    = '#d0d0d0'; // Bianco → grigio chiaro per visibilità su sfondo bianco

  function iconFill(fill) {
    const f = (fill || '').toLowerCase();
    if (f === 'letter_color') return DEFAULT_COLOR;
    if (f === '#ffffff' || f === 'white' || f === 'rgb(255,255,255)') return ICON_WHITE;
    return fill;
  }

  if (dec.type === 'svg-img') {
    return dec.svgTemplate
      .replaceAll('{{LETTER_COLOR}}', DEFAULT_COLOR)
      .replaceAll(/fill:\s*white/gi, `fill:${ICON_WHITE}`)
      .replaceAll(/fill="white"/gi, `fill="${ICON_WHITE}"`)
      .replaceAll(/fill="(#[Ff][Ff][Ff][Ff][Ff][Ff])"/g, `fill="${ICON_WHITE}"`)
      .replaceAll(/fill:rgb\(255,255,255\)/gi, `fill:${ICON_WHITE}`)
      .replaceAll(/fill:white/gi, `fill:${ICON_WHITE}`);
  }

  if (dec.type === 'svg') {
    const [vx, vy, vw, vh] = dec.svgViewBox;
    const paths = (dec.svgPaths || []).map(p => {
      const fill = iconFill(p.fill || dec.color || '#FFFFFF');
      const transform = p.transform
        ? `transform="matrix(${p.transform.join(',')})"`
        : '';
      return `<path d="${p.d}" fill="${fill}" ${transform}/>`;
    }).join('');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${vx} ${vy} ${vw} ${vh}">${paths}</svg>`;
  }

  return dec.icon;
}

/* ═══════════════════════════════════════════════════════
   TOAST — avvisi eleganti integrati nella pagina
═══════════════════════════════════════════════════════ */
function showToast(message, type = 'warn') {
  // Inietta lo stile una sola volta
  if (!document.getElementById('pl-toast-style')) {
    const st = document.createElement('style');
    st.id = 'pl-toast-style';
    st.textContent = `
      #pl-toast-overlay {
        position: fixed;
        inset: 0;
        background: rgba(40,30,15,0.28);
        backdrop-filter: blur(1.5px);
        z-index: 99999;
        opacity: 0;
        transition: opacity 0.25s ease;
        pointer-events: none;
      }
      #pl-toast-overlay.show { opacity: 1; }
      #pl-toast-container {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 14px;
        z-index: 100000;
        pointer-events: none;
        width: max-content;
        max-width: min(92vw, 540px);
      }
      .pl-toast {
        display: flex;
        align-items: center;
        gap: 1rem;
        background: #fffdf9;
        color: #3a3022;
        border: 1px solid #ecdfc2;
        border-top: 6px solid #c9a96e;
        border-radius: 18px;
        padding: 1.6rem 1.8rem;
        font-size: 1.3rem;
        line-height: 1.45;
        font-weight: 600;
        text-align: center;
        flex-direction: column;
        box-shadow: 0 20px 60px rgba(120,95,45,0.30);
        opacity: 0;
        transform: translateY(10px) scale(0.92);
        transition: opacity 0.28s ease, transform 0.28s cubic-bezier(0.2,0.7,0.3,1);
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
      }
      .pl-toast.show { opacity: 1; transform: translateY(0) scale(1); }
      .pl-toast-icon {
        flex-shrink: 0;
        width: 64px; height: 64px;
        border-radius: 50%;
        background: #f5ede0;
        display: flex; align-items: center; justify-content: center;
        font-size: 2rem;
      }
      .pl-toast-close {
        position: absolute;
        top: 10px; right: 12px;
        width: 32px; height: 32px;
        border: none;
        background: #f5ede0;
        color: #8a7350;
        border-radius: 50%;
        font-size: 1.1rem;
        line-height: 1;
        cursor: pointer;
        pointer-events: auto;
        display: flex; align-items: center; justify-content: center;
        transition: background 0.15s, color 0.15s, transform 0.15s;
      }
      .pl-toast-close:hover { background: #e7d6b6; color: #5a4a30; transform: scale(1.08); }
      .pl-toast { position: relative; }
      @media (max-width: 600px) {
        #pl-toast-container { max-width: 90vw; }
        .pl-toast { font-size: 1.15rem; padding: 1.4rem 1.4rem; border-radius: 16px; }
        .pl-toast-icon { width: 56px; height: 56px; font-size: 1.7rem; }
        .pl-toast-close { width: 30px; height: 30px; top: 8px; right: 8px; }
      }
    `;
    document.head.appendChild(st);
  }

  let overlay = document.getElementById('pl-toast-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'pl-toast-overlay';
    document.body.appendChild(overlay);
  }
  let container = document.getElementById('pl-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'pl-toast-container';
    document.body.appendChild(container);
  }

  const icon = type === 'warn' ? '⚠️' : 'ℹ️';
  const toast = document.createElement('div');
  toast.className = 'pl-toast';
  toast.innerHTML =
    `<button class="pl-toast-close" aria-label="Chiudi">✕</button>` +
    `<span class="pl-toast-icon">${icon}</span><span class="pl-toast-msg"></span>`;
  toast.querySelector('.pl-toast-msg').textContent = message;
  container.appendChild(toast);

  let closed = false;
  function dismiss() {
    if (closed) return;
    closed = true;
    clearTimeout(autoTimer);
    toast.classList.remove('show');
    setTimeout(() => {
      toast.remove();
      if (!container.querySelector('.pl-toast')) overlay.classList.remove('show');
    }, 320);
  }

  toast.querySelector('.pl-toast-close').addEventListener('click', dismiss);

  overlay.classList.add('show');
  requestAnimationFrame(() => toast.classList.add('show'));
  const autoTimer = setTimeout(dismiss, 4000);
}

// Decorazioni che possono essere inserite al massimo una volta
const SINGLE_INSTANCE_DEC_IDS = [1, 2, 5]; // Orsetto, Arcobaleno, Mongolfiera
// Limite massimo di istanze per tutte le altre decorazioni
const MAX_INSTANCES_PER_DEC = 3;
// Limite massimo di decorazioni DIVERSE (tipi) per lettera
const MAX_DIFFERENT_DECS = 4;

function selectDecoration(dec) {
  if (dec === null) {
    // Nessuna — deseleziona tutto
    state.decorations = [];
  } else {
    const currentCount = state.decorations.filter(id => id === dec.id).length;
    const uniqueIds = [...new Set(state.decorations)];

    // Vincolo: massimo MAX_DIFFERENT_DECS decorazioni diverse
    if (currentCount === 0 && uniqueIds.length >= MAX_DIFFERENT_DECS) {
      showToast(`Puoi combinare al massimo ${MAX_DIFFERENT_DECS} decorazioni diverse per lettera.`);
      return;
    }
    // Vincolo: alcune decorazioni ammettono una sola istanza
    if (SINGLE_INSTANCE_DEC_IDS.includes(dec.id) && currentCount >= 1) {
      showToast(`Puoi inserire una sola decorazione “${dec.name}” per lettera.`);
      return;
    }
    // Vincolo: tutte le altre al massimo MAX_INSTANCES_PER_DEC volte
    if (!SINGLE_INSTANCE_DEC_IDS.includes(dec.id) && currentCount >= MAX_INSTANCES_PER_DEC) {
      showToast(`Puoi inserire al massimo ${MAX_INSTANCES_PER_DEC} decorazioni “${dec.name}” per lettera.`);
      return;
    }
    // Aggiunge una nuova istanza
    state.decorations.push(dec.id);
  }
  updateDecButtons();
  document.getElementById('decWarning').style.display =
    state.decorations.length > 3 ? 'block' : 'none';
  render();
}

function removeDecoration(decId) {
  // Rimuove TUTTE le istanze di questa decorazione
  state.decorations = state.decorations.filter(id => id !== decId);
  updateDecButtons();
  document.getElementById('decWarning').style.display =
    state.decorations.length > 3 ? 'block' : 'none';
  render();
}

/* ═══════════════════════════════════════════════════════
   INIT
═══════════════════════════════════════════════════════ */

buildColorSwatches('letterColorSwatches',
  () => state.letterColor,
  color => {
    state.letterColor = color;
    document.getElementById('letterColorLabel').textContent = color.name;
    document.getElementById('nameColorSection').classList.toggle('visible', isWhite(color.hex));
    render();
  }
);

buildColorSwatches('nameColorSwatches',
  () => state.nameColor,
  color => {
    state.nameColor = color;
    document.getElementById('nameColorLabel').textContent = color.name;
    render();
  }
);

buildDecorations();

// ── Ripristina nella UI lo stato caricato da localStorage ──
document.getElementById('letterInput').value = state.letter;
document.getElementById('nameInput').value   = state.name;
document.getElementById('letterColorLabel').textContent = state.letterColor.name;
document.getElementById('nameColorLabel').textContent   = state.nameColor.name;
document.getElementById('nameColorSection').classList.toggle('visible', isWhite(state.letterColor.hex));
if (typeof updateDecButtons === 'function') updateDecButtons();

document.getElementById('letterInput').addEventListener('input', e => {
  state.letter = e.target.value.toUpperCase();
  render();
});

document.getElementById('nameInput').addEventListener('input', e => {
  state.name = e.target.value.replace(/\S+/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  render();
});

initFonts();

/* ═══════════════════════════════════════════════════════
   NOTICE POSIZIONI NON CONFIGURATE
═══════════════════════════════════════════════════════ */

const noPositionNotice = document.getElementById('noPositionNotice');

function updatePositionNotice() {
  if (state.decorations.length === 0) {
    noPositionNotice.style.display = 'none';
    return;
  }
  const L = state.letter.toUpperCase();
  const activeIds = [...new Set(state.decorations)].sort((a, b) => a - b);
  let usingDefault = false;

  if (activeIds.length > 1) {
    // Con più decorazioni: la combinazione è configurata solo se TUTTI
    // i dec hanno la rispettiva chiave combo. Se anche uno solo manca → avviso.
    const combo = activeIds.join('+');
    const comboConfigured = activeIds.every(decId =>
      !!DECORATION_POSITIONS[`${L}_${combo}_${decId}`]
    );
    usingDefault = !comboConfigured;
  } else {
    // Decorazione singola: avviso se manca la chiave singola
    usingDefault = !DECORATION_POSITIONS[`${L}_${activeIds[0]}`];
  }

  noPositionNotice.style.display = usingDefault ? 'block' : 'none';
}

/* ═══════════════════════════════════════════════════════
   GALLERY REALE
═══════════════════════════════════════════════════════ */

const GALLERY_API = 'https://studioviman.it/imagedb/api/gallery.php';
const GALLERY_IMG_BASE = 'https://studioviman.it/imagedb/uploads/ai/';

// Lista (in ordine) delle foto attualmente mostrate nella gallery — usata dal lightbox
let galleryImages = [];

// Mappa ID decorazione → nome nell'archivio
const DEC_ID_TO_NAME = {
  1: 'Orsetto',
  2: 'Arcobaleno',
  3: 'Farfalla',
  4: 'Nuvoletta',
  5: 'Mongolfiera',
  6: 'Cuore',
  7: 'Stella',
};

let _galleryData = null; // cache fetch

async function loadGalleryData() {
  if (_galleryData) return _galleryData;
  try {
    const res = await fetch(GALLERY_API);
    _galleryData = await res.json();
  } catch (e) {
    _galleryData = [];
  }
  return _galleryData;
}

// Normalizza stringa: lowercase + rimuove accenti/diacritici
function normalizeStr(s) {
  return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

async function updateGallery() {
  const box  = document.getElementById('galleryBox');
  const grid = document.getElementById('galleryGrid');

  const { letter, name, letterColor } = state;
  if (!letter) { box.style.display = 'none'; return; }

  const data = await loadGalleryData();

  const matches = data.filter(img => {
    // Lettera (case-insensitive)
    if (img.lettera.toUpperCase() !== letter.toUpperCase()) return false;
    // Colore: match flessibile (es. "Salvia" ⊂ "Verde Salvia")
    const archColor    = normalizeStr(img.colore_lettera);
    const previewColor = normalizeStr(letterColor.name);
    if (!archColor.includes(previewColor) && !previewColor.includes(archColor)) return false;
    // Nome: normalizzato (toglie accenti) + case-insensitive
    if (normalizeStr(img.nome) !== normalizeStr(name)) return false;
    return true;
  });

  if (matches.length === 0) {
    box.style.display = 'none';
    return;
  }

  galleryImages = matches.map(img => `${GALLERY_IMG_BASE}${img.filename}`);

  grid.innerHTML = matches.map((img, i) => `
    <div class="gallery-thumb" data-index="${i}">
      <img src="${GALLERY_IMG_BASE}${img.filename}" alt="${img.nome}" loading="lazy">
    </div>
  `).join('');

  // Click → lightbox (con navigazione)
  grid.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => openLightbox(parseInt(thumb.dataset.index, 10)));
  });

  box.style.display = 'flex';
  grid.scrollLeft = 0;
  updateGalleryArrows();
}

/* Frecce gallery */
function updateGalleryArrows() {
  const grid = document.getElementById('galleryGrid');
  const prev = document.getElementById('galleryPrev');
  const next = document.getElementById('galleryNext');
  if (!grid || !prev || !next) return;
  const overflow = grid.scrollWidth - grid.clientWidth > 4;
  prev.style.display = overflow ? 'flex' : 'none';
  next.style.display = overflow ? 'flex' : 'none';
  if (overflow) {
    prev.disabled = grid.scrollLeft <= 2;
    next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
  }
}

(function setupGalleryArrows() {
  const grid = document.getElementById('galleryGrid');
  const prev = document.getElementById('galleryPrev');
  const next = document.getElementById('galleryNext');
  if (!grid || !prev || !next) return;
  const step = () => Math.max(grid.clientWidth * 0.8, 120);
  prev.addEventListener('click', () => grid.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => grid.scrollBy({ left:  step(), behavior: 'smooth' }));
  grid.addEventListener('scroll', () => window.requestAnimationFrame(updateGalleryArrows), { passive: true });
  window.addEventListener('resize', updateGalleryArrows, { passive: true });
})();

// Lightbox (con navigazione tra le foto)
const lightbox      = document.getElementById('galleryLightbox');
const lightboxImg   = document.getElementById('galleryLightboxImg');
const lightboxClose = document.getElementById('galleryLightboxClose');
const lightboxPrev  = document.getElementById('galleryLightboxPrev');
const lightboxNext  = document.getElementById('galleryLightboxNext');

let lightboxIndex = 0;

function showLightboxAt(i) {
  if (!galleryImages.length) return;
  lightboxIndex = (i + galleryImages.length) % galleryImages.length;
  lightboxImg.src = galleryImages[lightboxIndex];
  const multi = galleryImages.length > 1;
  if (lightboxPrev) lightboxPrev.style.display = multi ? 'flex' : 'none';
  if (lightboxNext) lightboxNext.style.display = multi ? 'flex' : 'none';
}

function openLightbox(i) {
  showLightboxAt(typeof i === 'number' ? i : 0);
  lightbox.classList.add('open');
}
function closeLightbox() { lightbox.classList.remove('open'); }

lightboxClose.addEventListener('click', closeLightbox);
lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });

if (lightboxPrev) lightboxPrev.addEventListener('click', e => { e.stopPropagation(); showLightboxAt(lightboxIndex - 1); });
if (lightboxNext) lightboxNext.addEventListener('click', e => { e.stopPropagation(); showLightboxAt(lightboxIndex + 1); });

// Tastiera
document.addEventListener('keydown', e => {
  if (!lightbox.classList.contains('open')) return;
  if (e.key === 'Escape') closeLightbox();
  else if (e.key === 'ArrowLeft')  showLightboxAt(lightboxIndex - 1);
  else if (e.key === 'ArrowRight') showLightboxAt(lightboxIndex + 1);
});

// Swipe su mobile
let lbTouchX = 0;
lightbox.addEventListener('touchstart', e => { lbTouchX = e.changedTouches[0].clientX; }, { passive: true });
lightbox.addEventListener('touchend', e => {
  const dx = e.changedTouches[0].clientX - lbTouchX;
  if (Math.abs(dx) > 50) showLightboxAt(lightboxIndex + (dx < 0 ? 1 : -1));
}, { passive: true });

/* ═══════════════════════════════════════════════════════
   SHOPIFY CART INTEGRATION
   — Lettera base + ogni decorazione come variante separata
═══════════════════════════════════════════════════════ */

// Mappa ID decorazione → Variant ID Shopify del prodotto decorazioni
const DEC_VARIANT_IDS = {
  1: 52295811727699,  // Orsetto
  2: 52295811924307,  // Arcobaleno
  3: 52295811826003,  // Farfalla
  4: 52295811760467,  // Nuvoletta
  5: 52295811793235,  // Mongolfiera
  6: 52295811858771,  // Cuore
  7: 52295811891539,  // Stella
};

/**
 * Crea una miniatura JPEG compressa dell'anteprima (canvas) come data URL.
 * Dimensione ridotta per stare nei limiti delle proprietà di riga del carrello.
 * Ritorna null se il canvas è "tainted" (CORS) o in caso di errore.
 */
function generatePreviewThumbnail() {
  try {
    const src = document.getElementById('previewCanvas');
    if (!src) return null;
    const SIZE = 480; // più grande per buona resa anche nelle email
    const tc = document.createElement('canvas');
    tc.width  = SIZE;
    tc.height = SIZE;
    const tctx = tc.getContext('2d');
    // Sfondo bianco (JPEG non ha trasparenza)
    tctx.fillStyle = '#ffffff';
    tctx.fillRect(0, 0, SIZE, SIZE);
    tctx.drawImage(src, 0, 0, SIZE, SIZE);
    return tc.toDataURL('image/jpeg', 0.72);
  } catch (err) {
    console.warn('Anteprima non generata:', err);
    return null;
  }
}

// Endpoint sul tuo server che salva l'anteprima e restituisce un URL pubblico
const CART_PREVIEW_API = 'https://studioviman.it/imagedb/api/cart_preview.php';

/**
 * Carica la miniatura (data URL) sul server e restituisce l'URL pubblico.
 * Serve perché i client di posta NON renderizzano i data URL: per la mail di
 * carrello abbandonato occorre un vero link immagine. Ritorna null se fallisce.
 */
async function uploadPreviewImage(dataUrl) {
  try {
    // Content-Type "text/plain" → richiesta CORS "semplice", niente preflight OPTIONS.
    // Il server legge comunque il body grezzo (php://input).
    const res = await fetch(CART_PREVIEW_API, {
      method:  'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body:    JSON.stringify({ image: dataUrl }),
    });
    if (!res.ok) return null;
    const json = await res.json();
    return (json && json.url) ? json.url : null;
  } catch (err) {
    console.warn('Upload anteprima non riuscito:', err);
    return null;
  }
}

/**
 * Trova l'ID della variante prodotto che corrisponde al colore lettera (e nome)
 * attualmente selezionato. Ritorna null se non c'è corrispondenza.
 * I dati varianti sono iniettati da Liquid in window.PL_VARIANTS / PL_OPTION_NAMES.
 */
function findLetterVariantId() {
  try {
    if (!Array.isArray(window.PL_VARIANTS) || !Array.isArray(window.PL_OPTION_NAMES)) return null;
    const names = window.PL_OPTION_NAMES.map(n => String(n).toLowerCase());
    const li = names.findIndex(n => n.includes('lettera')); // opzione "Colore Lettera"
    const ni = names.findIndex(n => n.includes('nome'));    // opzione "Colore Nome"

    const wantLetter = state.letterColor.name.toLowerCase();
    const wantName   = (isWhite(state.letterColor.hex) ? state.nameColor.name : 'Bianco').toLowerCase();
    const opts = v => (v.options || []).map(o => String(o).toLowerCase());

    // 1) match esatto colore lettera + colore nome
    let m = window.PL_VARIANTS.find(v =>
      (li < 0 || opts(v)[li] === wantLetter) &&
      (ni < 0 || opts(v)[ni] === wantName)
    );
    // 2) fallback: solo colore lettera (il nome è bianco sulle lettere colorate)
    if (!m) m = window.PL_VARIANTS.find(v => li < 0 || opts(v)[li] === wantLetter);

    return m ? m.id : null;
  } catch (e) {
    return null;
  }
}

document.getElementById('addToCartForm').addEventListener('submit', async function(e) {
  e.preventDefault();

  const letter = state.letter || '';
  const name   = state.name   || '';
  if (!letter || !name) {
    alert('⚠️ Inserisci la lettera e il nome prima di procedere!');
    return;
  }

  const btn = this.querySelector('.btn-primary');
  const originalText = btn.textContent;
  btn.textContent = 'Aggiunta in corso…';
  btn.disabled = true;

  // Proprietà personalizzate per la lettera base
  const decNames = [...state.decorations]
    .map(id => DEC_ID_TO_NAME[id]).filter(Boolean);

  const baseProperties = {
    'Lettera':     letter.toUpperCase(),
    'Nome':        name,
    'Decorazioni': decNames.length ? decNames.join(', ') : 'Nessuna',
  };

  // Trova la variante prodotto che corrisponde al colore scelto, così carrello
  // e ordine mostrano il colore corretto nativamente (niente più "Rosa" fisso).
  const matchedVariantId = findLetterVariantId();
  // Se non troviamo la variante, ripieghiamo sulla proprietà (l'info non si perde)
  if (!matchedVariantId) {
    baseProperties['Colore lettera'] = state.letterColor.name;
  }

  // Assicura che il canvas rifletta lo stato attuale (decorazioni caricate)
  try { await render(); } catch (_) {}

  // Genera una miniatura JPEG dell'anteprima.
  // La carica sul server per ottenere un URL pubblico (usabile anche nelle email
  // di carrello abbandonato). Se l'upload fallisce, ripiega sul data URL così
  // l'anteprima resta comunque visibile nel carrello sul sito.
  // Il prefisso "_" rende la proprietà invisibile nell'elenco del carrello,
  // ma resta leggibile dal template Liquid e salvata nell'ordine.
  const previewThumb = generatePreviewThumbnail();
  if (previewThumb) {
    const uploadedUrl = await uploadPreviewImage(previewThumb);
    baseProperties['_preview'] = uploadedUrl || previewThumb;
  }

  // Variante lettera base: quella col colore giusto, o quella di default come fallback
  const baseVariantId = matchedVariantId || parseInt(
    this.querySelector('input[name="id"]').value
  );

  // Costruisci array items: lettera + decorazioni (raggruppate per quantità)
  const decCounts = {};
  state.decorations.forEach(id => { decCounts[id] = (decCounts[id] || 0) + 1; });
  const decItems = Object.entries(decCounts).map(([decIdStr, qty]) => ({
    id:       DEC_VARIANT_IDS[Number(decIdStr)],
    quantity: qty,
    properties: {
      'Per':     name,
      'Lettera': letter.toUpperCase(),
    },
  })).filter(item => item.id);

  const items = [
    {
      id:         baseVariantId,
      quantity:   1,
      properties: baseProperties,
    },
    ...decItems,
  ];

  try {
    const res = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items }),
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Errore aggiunta al carrello');
    }

    // Redirect al carrello
    window.location.href = '/cart';

  } catch (err) {
    alert('⚠️ ' + err.message);
    btn.textContent = originalText;
    btn.disabled = false;
  }
});
/* ═══════════════════════════════════════════════════════
   LEAD CAPTURE — popup "Salva la tua creazione"
   Cattura email (+ telefono opzionale) dagli utenti coinvolti
   e li iscrive a Klaviyo, restituendo un codice sconto.
═══════════════════════════════════════════════════════ */
(function () {
  // ── CONFIG (modifica questi valori) ─────────────────────────────
  const KLAVIYO_PUBLIC_KEY   = 'VK5FNB';      // chiave pubblica Klaviyo (company_id)
  const KLAVIYO_LEADS_LIST_ID = 'RatwqK';     // ID lista Klaviyo ("Email List"); cambiala se vuoi una lista dedicata
  const LEAD_DISCOUNT_CODE   = 'LETTERA10';   // codice sconto 10% (crealo in Shopify → Sconti)
  const ENGAGE_MS            = 70000;         // dopo 70s di permanenza
  const MIN_INTERACTIONS     = 3;             // e almeno 3 interazioni
  const RESHOW_DAYS          = 14;            // non rimostrare per 14 giorni
  // ────────────────────────────────────────────────────────────────

  const modal   = document.getElementById('plLeadModal');
  if (!modal) return;
  const formWrap = document.getElementById('plLeadFormWrap');
  const form     = document.getElementById('plLeadForm');
  const emailEl  = document.getElementById('plLeadEmail');
  const phoneEl  = document.getElementById('plLeadPhone');
  const consent  = document.getElementById('plLeadConsent');
  const submitEl = document.getElementById('plLeadSubmit');
  const errorEl  = document.getElementById('plLeadError');
  const closeEl  = document.getElementById('plLeadClose');
  const skipEl   = document.getElementById('plLeadSkip');
  const successEl = document.getElementById('plLeadSuccess');
  const codeEl   = document.getElementById('plLeadCode');
  const thumbEl  = document.getElementById('plLeadThumb');
  const subEl    = document.getElementById('plLeadSub');

  codeEl.textContent = LEAD_DISCOUNT_CODE;

  let interactions = 0;
  let shownThisSession = false;

  // Stato persistente: 'done' (iscritto) o 'shown:<timestamp>'
  function leadState() { try { return localStorage.getItem('pl_lead') || ''; } catch (e) { return ''; } }
  function setLeadState(v) { try { localStorage.setItem('pl_lead', v); } catch (e) {} }

  function canShow() {
    if (shownThisSession) return false;
    const s = leadState();
    if (s === 'done') return false;
    if (s.indexOf('shown:') === 0) {
      const ts = parseInt(s.split(':')[1], 10) || 0;
      if (Date.now() - ts < RESHOW_DAYS * 86400000) return false;
    }
    return true;
  }

  function open() {
    if (!canShow()) return;
    shownThisSession = true;
    setLeadState('shown:' + Date.now());

    // Anteprima della creazione (miniatura dal canvas)
    try {
      const thumb = (typeof generatePreviewThumbnail === 'function') ? generatePreviewThumbnail() : null;
      if (thumb) thumbEl.src = thumb;
    } catch (e) {}

    // Personalizza il testo col nome (se presente e normalizzato)
    try {
      const nm = (state.name || '').trim().split(/\s+/)
        .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
      if (nm) {
        subEl.innerHTML = `Lasciaci la tua email: ti inviamo l'anteprima della tua <strong>${nm}</strong> ` +
          `e un <strong>10% di sconto</strong> per completarla quando vuoi.`;
      }
    } catch (e) {}

    modal.classList.add('open');
    setTimeout(() => { try { emailEl.focus(); } catch (e) {} }, 100);
  }

  function close() { modal.classList.remove('open'); }

  // ── Trigger di coinvolgimento ──
  function bump() { interactions++; }
  ['letterInput', 'nameInput'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('input', bump);
  });
  document.addEventListener('click', e => {
    if (e.target.closest && e.target.closest('.dec-btn, .pl-color-swatch')) bump();
  });

  // Tempo: dopo ENGAGE_MS, se abbastanza coinvolto
  setTimeout(() => { if (interactions >= MIN_INTERACTIONS) open(); }, ENGAGE_MS);

  // Exit intent (desktop): il mouse esce dall'alto della pagina
  document.addEventListener('mouseout', e => {
    if (e.clientY <= 0 && !e.relatedTarget && interactions >= 1) open();
  });

  // ── Chiusura ──
  closeEl.addEventListener('click', close);
  if (skipEl) skipEl.addEventListener('click', close);
  modal.addEventListener('click', e => { if (e.target === modal) close(); });

  // ── Copia codice ──
  codeEl.addEventListener('click', () => {
    try {
      navigator.clipboard.writeText(LEAD_DISCOUNT_CODE);
      const old = codeEl.textContent;
      codeEl.textContent = 'Copiato!';
      setTimeout(() => { codeEl.textContent = old; }, 1200);
    } catch (e) {}
  });

  // ── Invio a Klaviyo ──
  form.addEventListener('submit', async e => {
    e.preventDefault();
    errorEl.classList.remove('show');

    const email = (emailEl.value || '').trim();
    const phone = (phoneEl.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      errorEl.textContent = 'Inserisci un indirizzo email valido.';
      errorEl.classList.add('show');
      return;
    }
    if (!consent.checked) {
      errorEl.textContent = 'Spunta il consenso per continuare.';
      errorEl.classList.add('show');
      return;
    }

    submitEl.disabled = true;
    const originalLabel = submitEl.textContent;
    submitEl.textContent = 'Invio…';

    // Anteprima → URL pubblico (best effort)
    let previewUrl = null;
    try {
      const thumb = (typeof generatePreviewThumbnail === 'function') ? generatePreviewThumbnail() : null;
      if (thumb && typeof uploadPreviewImage === 'function') previewUrl = await uploadPreviewImage(thumb);
    } catch (e) {}

    // Proprietà profilo
    const decNames = [...state.decorations].map(id => DEC_ID_TO_NAME[id]).filter(Boolean);
    const properties = {
      'Lettera':        (state.letter || '').toUpperCase(),
      'Nome':           state.name || '',
      'Colore lettera': state.letterColor.name,
      'Decorazioni':    decNames.length ? decNames.join(', ') : 'Nessuna',
      'Codice sconto':  LEAD_DISCOUNT_CODE,
      'Origine':        'Configuratore Lettera',
    };
    if (phone) properties['Telefono'] = phone; // come proprietà (no SMS finché non configurato)
    if (previewUrl) properties['Anteprima'] = previewUrl;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Configuratore Lettera',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: properties },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LEADS_LIST_ID } } },
      },
    };

    try {
      const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload),
      });
      if (res.status !== 202 && !res.ok) throw new Error('Klaviyo ' + res.status);

      // Successo
      setLeadState('done');
      formWrap.style.display = 'none';
      successEl.classList.add('show');
    } catch (err) {
      console.warn('Iscrizione lead non riuscita:', err);
      errorEl.textContent = 'Qualcosa è andato storto. Riprova tra poco.';
      errorEl.classList.add('show');
      submitEl.disabled = false;
      submitEl.textContent = originalLabel;
    }
  });
})();
